export const borrower = "borrower"
export const coborrower = "coborrower"

/**
 * Whether Smartlook session recording should be enabled.
 * Returns false when hostname contains localhost, .us, or .net.
 */
export function shouldRecordSmartlook() {
    if (typeof window === 'undefined') return false;
    const h = window.location.hostname;
    return !h.includes('localhost') && !h.includes('.us') && !h.includes('.net');
}

export function getStrataApiBaseUrl() {
	if (typeof window === "undefined") return "https://zeitro.net"

	const hostname = window.location.hostname || ""

	if (hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1") {
		return "https://zeitro.net"
	}

	if (hostname.endsWith(".net")) {
		return "https://zeitro.net"
	}

	if (hostname.endsWith(".com")) {
		return "https://zeitro.com"
	}

	return "https://zeitro.net"
}

export function getEnvironment() {
    if (process.env.NODE_ENV === 'development') {
        return 'development'
    }

    const hostname = window.location.hostname
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('192.168.') || hostname.endsWith('.zeitro.net')) {
        return 'development'
    }
	
    if (hostname.endsWith('.zeitro.us')) {
        return 'staging'
    }
    
    return 'production'
}

export function getUserId() {
	const token = sessionStorage.getItem("ZeitroA")
	if (!token) return -1

	const jes = atob(token.split('.')[1])
	const js = JSON.parse(jes)
	return js.id
}

export function getStatus(id, list) {
	if (!list) return undefined
	const status = list.find(item => item.ID === id)
	return status === undefined ? null : status.AccountTier
}

export function getLoId() {
	const token = sessionStorage.getItem("ZeitroA")
	if (!token) return -1

	const jes = atob(token.split('.')[1])
	const js = JSON.parse(jes)
	return js.loanofficerid
}

export function getLoInfo() {
	const token = sessionStorage.getItem("ZeitroA")
	if (!token) return -1

	const jes = atob(token.split('.')[1])
	const js = JSON.parse(jes)
	return js
}

export function getFreeStatus(subscriptionPlan, loanOfficers) {
	if (getCustomerId() === 'greenbox' || getCustomerId() === 'nationdirect' || getCustomerId() === 'calhfa') return false
	const status = getStatus(getLoId(), loanOfficers)
	if (
		subscriptionPlan === 'starter' ||
		(subscriptionPlan === 'business' && status === 'free')
	) {
		return true
	}
	return false
}

export function getUserToken() {
	return sessionStorage.getItem("ZeitroA")
}

let customerid = null
export function getCustomerId() {
	if (customerid != null) return customerid

	const token = getUserToken()
	if (null == token) return null
	const sp = token.split('.')
	const s = atob(sp[1])
	const j = JSON.parse(s)
	customerid = j.customerid
	return j.customerid
}

// Clear customerId cache (useful after login/logout)
export function clearCustomerIdCache() {
	customerid = null
}

export function isHardMoneyLoanCustomer() {
	const token = getUserToken()
	if (null == token) return null
	const sp = token.split('.')
	const s = atob(sp[1])
	const j = JSON.parse(s)
	return j.ishardmoneyloancustomer
}

export function getCustomerEmail() {
	const token = sessionStorage.getItem("ZeitroA")
	if (!token) return ""

	const jes = atob(token.split('.')[1])
	const js = JSON.parse(jes)
	return js.email
}


export function hex2ascii(hex) {
	// first build array
	const arr = []
	for (let i = 0; i < hex.length; i += 2) {
		arr.push(parseInt(hex.substr(i, 2), 16))
	}

	const dec = new TextDecoder()
	const str = dec.decode(Uint8Array.from(arr))
	return str
}

export function ascii2hex(str) {
	const encoder = new TextEncoder()
	const arr = encoder.encode(str)
	let hex = ''
	for (let i = 0; i < arr.length; i++) {
		hex += arr[i].toString(16);
	}

	return hex
}

export function fixPhoneInput(input, delimiter = '-') {
	// 如果输入为空，直接返回
	if (!input || input.length === 0) {
		return ''
	}

	// 清理输入，只保留数字、括号、空格和连字符
	let cleanedInput = input.replace(/[^0-9()\-\ ]/g, '')
	
	// 如果清理后为空，返回空字符串
	if (!cleanedInput || cleanedInput.length === 0) {
		return ''
	}

	// 如果第一个字符不是数字也不是左括号，返回空字符串
	if (!/^\d$/.test(cleanedInput[0]) && cleanedInput[0] !== '(') {
		return ''
	}

	// 提取所有数字
	const digits = cleanedInput.replace(/\D/g, '')
	
	// 根据数字长度进行格式化
	if (digits.length === 0) {
		return ''
	} else if (digits.length === 1) {
		return '(' + digits[0]
	} else if (digits.length === 2) {
		return '(' + digits[0] + digits[1]
	} else if (digits.length === 3) {
		return '(' + digits[0] + digits[1] + digits[2]
	} else if (digits.length === 4) {
		return '(' + digits[0] + digits[1] + digits[2] + ') ' + digits[3]
	} else if (digits.length === 5) {
		return '(' + digits[0] + digits[1] + digits[2] + ') ' + digits[3] + digits[4]
	} else if (digits.length === 6) {
		return '(' + digits[0] + digits[1] + digits[2] + ') ' + digits[3] + digits[4] + digits[5]
	} else if (digits.length === 7) {
		return '(' + digits[0] + digits[1] + digits[2] + ') ' + digits[3] + digits[4] + digits[5] + delimiter + digits[6]
	} else if (digits.length === 8) {
		return '(' + digits[0] + digits[1] + digits[2] + ') ' + digits[3] + digits[4] + digits[5] + delimiter + digits[6] + digits[7]
	} else if (digits.length === 9) {
		return '(' + digits[0] + digits[1] + digits[2] + ') ' + digits[3] + digits[4] + digits[5] + delimiter + digits[6] + digits[7] + digits[8]
	} else if (digits.length >= 10) {
		return '(' + digits[0] + digits[1] + digits[2] + ') ' + digits[3] + digits[4] + digits[5] + delimiter + digits[6] + digits[7] + digits[8] + digits[9]
	}

	return cleanedInput.substring(0, 14)
}

// Regular expression pattern for validating phone numbers
// Works with both Ant Design Form rules and HTML5 pattern attribute
export const phoneRegex = "^\\([1-9][0-9]{2,2}\\) [0-9]{3,3}-[0-9]{4,4}$"

export const phonePlaceholder = "(XXX) XXX-XXXX"

export const phoneRegexMessage = "Please enter a valid phone number (10 digits)."

// Regular expression for validating email addresses
export const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/

export function fixDateInput(input) {
	// Based upon the length of the string, we add formatting as necessary
	var size = input.length;
	if (size === 2) {
		if (input[1] === '/')
			input = '0' + input
	} else if (size <= 2) {
		input = input.replace(/\D/g, '');
	} else if (size === 3) {
		if (input[2] === '/') {
		} else {
			input = input.substr(0, 2) + '/' + input[2]
		}
	} else if (size === 6) {
		if (input[5] === '/') {
		} else {
			input = input.substr(0, 5) + '/' + input[5]
		}
	}
	input = input.replace(/[^0-9/]/g, '');
	input = input.substring(0, 10);
	return input;
}

export function fixSSN(input) {
	var size = input.length;
	if (size <= 3) {
		input = input.replace(/\D/g, '');
	} else if (size === 4) {
		if (input[3] !== '-') {
			input = input.substr(0, 3) + "-" + input[3]
		}
	} else if (size === 7) {
		if (input[6] !== '-') {
			input = input.substr(0, 6) + "-" + input[6]
		}
	}
	input = input.replace(/[^0-9-]/g, '');
	input = input.substr(0, 11)
	return input;
}
export const mapAbbrFullName = { "AZ": "Arizona", "AL": "Alabama", "AK": "Alaska", "AR": "Arkansas", "CA": "California", "CO": "Colorado", "CT": "Connecticut", "DC": "District of Columbia", "DE": "Delaware", "FL": "Florida", "GA": "Georgia", "HI": "Hawaii", "ID": "Idaho", "IL": "Illinois", "IN": "Indiana", "IA": "Iowa", "KS": "Kansas", "KY": "Kentucky", "LA": "Louisiana", "ME": "Maine", "MD": "Maryland", "MA": "Massachusetts", "MI": "Michigan", "MN": "Minnesota", "MS": "Mississippi", "MO": "Missouri", "MT": "Montana", "NE": "Nebraska", "NV": "Nevada", "NH": "New Hampshire", "NJ": "New Jersey", "NM": "New Mexico", "NY": "New York", "NC": "North Carolina", "ND": "North Dakota", "OH": "Ohio", "OK": "Oklahoma", "OR": "Oregon", "PA": "Pennsylvania", "RI": "Rhode Island", "SC": "South Carolina", "SD": "South Dakota", "TN": "Tennessee", "TX": "Texas", "UT": "Utah", "VT": "Vermont", "VA": "Virginia", "WA": "Washington", "WV": "West Virginia", "WI": "Wisconsin", "WY": "Wyoming", "AB": "Alberta", "BC": "British Columbia", "MB": "Manitoba", "NB": "New Brunswick", "NF": "Newfoundland", "NT": "Northwest Territory", "NS": "Nova Scotia", "NU": "Nunavut", "ON": "Ontario", "PE": "Prince Edward Island", "QC": "Quebec", "SK": "Saskatchewan", "YT": "Yukon" };
export const mapFullNameAbbr = { "arizona": "AZ", "alabama": "AL", "alaska": "AK", "arkansas": "AR", "california": "CA", "colorado": "CO", "connecticut": "CT", "districtofcolumbia": "DC", "delaware": "DE", "florida": "FL", "georgia": "GA", "hawaii": "HI", "idaho": "ID", "illinois": "IL", "indiana": "IN", "iowa": "IA", "kansas": "KS", "kentucky": "KY", "louisiana": "LA", "maine": "ME", "maryland": "MD", "massachusetts": "MA", "michigan": "MI", "minnesota": "MN", "mississippi": "MS", "missouri": "MO", "montana": "MT", "nebraska": "NE", "nevada": "NV", "newhampshire": "NH", "newjersey": "NJ", "newmexico": "NM", "newyork": "NY", "northcarolina": "NC", "northdakota": "ND", "ohio": "OH", "oklahoma": "OK", "oregon": "OR", "pennsylvania": "PA", "rhodeisland": "RI", "southcarolina": "SC", "southdakota": "SD", "tennessee": "TN", "texas": "TX", "utah": "UT", "vermont": "VT", "virginia": "VA", "washington": "WA", "westvirginia": "WV", "wisconsin": "WI", "wyoming": "WY", "alberta": "AB", "britishcolumbia": "BC", "manitoba": "MB", "newbrunswick": "NB", "newfoundland": "NF", "northwestterritory": "NT", "novascotia": "NS", "nunavut": "NU", "ontario": "ON", "princeedwardisland": "PE", "quebec": "QC", "saskatchewan": "SK", "yukon": "YT" }
export const mapCountry = {"BD":"Bangladesh","BE":"Belgium","BF":"Burkina Faso","BG":"Bulgaria","BA":"Bosnia and Herzegovina","BB":"Barbados","WF":"Wallis and Futuna","BL":"Saint Barthelemy","BM":"Bermuda","BN":"Brunei","BO":"Bolivia","BH":"Bahrain","BI":"Burundi","BJ":"Benin","BT":"Bhutan","JM":"Jamaica","BV":"Bouvet Island","BW":"Botswana","WS":"Samoa","BQ":"Bonaire, Saint Eustatius and Saba ","BR":"Brazil","BS":"Bahamas","JE":"Jersey","BY":"Belarus","BZ":"Belize","RU":"Russia","RW":"Rwanda","RS":"Serbia","TL":"East Timor","RE":"Reunion","TM":"Turkmenistan","TJ":"Tajikistan","RO":"Romania","TK":"Tokelau","GW":"Guinea-Bissau","GU":"Guam","GT":"Guatemala","GS":"South Georgia and the South Sandwich Islands","GR":"Greece","GQ":"Equatorial Guinea","GP":"Guadeloupe","JP":"Japan","GY":"Guyana","GG":"Guernsey","GF":"French Guiana","GE":"Georgia","GD":"Grenada","GB":"United Kingdom","GA":"Gabon","SV":"El Salvador","GN":"Guinea","GM":"Gambia","GL":"Greenland","GI":"Gibraltar","GH":"Ghana","OM":"Oman","TN":"Tunisia","JO":"Jordan","HR":"Croatia","HT":"Haiti","HU":"Hungary","HK":"Hong Kong","HN":"Honduras","HM":"Heard Island and McDonald Islands","VE":"Venezuela","PR":"Puerto Rico","PS":"Palestinian Territory","PW":"Palau","PT":"Portugal","SJ":"Svalbard and Jan Mayen","PY":"Paraguay","IQ":"Iraq","PA":"Panama","PF":"French Polynesia","PG":"Papua New Guinea","PE":"Peru","PK":"Pakistan","PH":"Philippines","PN":"Pitcairn","PL":"Poland","PM":"Saint Pierre and Miquelon","ZM":"Zambia","EH":"Western Sahara","EE":"Estonia","EG":"Egypt","ZA":"South Africa","EC":"Ecuador","IT":"Italy","VN":"Vietnam","SB":"Solomon Islands","ET":"Ethiopia","SO":"Somalia","ZW":"Zimbabwe","SA":"Saudi Arabia","ES":"Spain","ER":"Eritrea","ME":"Montenegro","MD":"Moldova","MG":"Madagascar","MF":"Saint Martin","MA":"Morocco","MC":"Monaco","UZ":"Uzbekistan","MM":"Myanmar","ML":"Mali","MO":"Macao","MN":"Mongolia","MH":"Marshall Islands","MK":"Macedonia","MU":"Mauritius","MT":"Malta","MW":"Malawi","MV":"Maldives","MQ":"Martinique","MP":"Northern Mariana Islands","MS":"Montserrat","MR":"Mauritania","IM":"Isle of Man","UG":"Uganda","TZ":"Tanzania","MY":"Malaysia","MX":"Mexico","IL":"Israel","FR":"France","IO":"British Indian Ocean Territory","SH":"Saint Helena","FI":"Finland","FJ":"Fiji","FK":"Falkland Islands","FM":"Micronesia","FO":"Faroe Islands","NI":"Nicaragua","NL":"Netherlands","NO":"Norway","NA":"Namibia","VU":"Vanuatu","NC":"New Caledonia","NE":"Niger","NF":"Norfolk Island","NG":"Nigeria","NZ":"New Zealand","NP":"Nepal","NR":"Nauru","NU":"Niue","CK":"Cook Islands","XK":"Kosovo","CI":"Ivory Coast","CH":"Switzerland","CO":"Colombia","CN":"China","CM":"Cameroon","CL":"Chile","CC":"Cocos Islands","CA":"Canada","CG":"Republic of the Congo","CF":"Central African Republic","CD":"Democratic Republic of the Congo","CZ":"Czech Republic","CY":"Cyprus","CX":"Christmas Island","CR":"Costa Rica","CW":"Curacao","CV":"Cape Verde","CU":"Cuba","SZ":"Swaziland","SY":"Syria","SX":"Sint Maarten","KG":"Kyrgyzstan","KE":"Kenya","SS":"South Sudan","SR":"Suriname","KI":"Kiribati","KH":"Cambodia","KN":"Saint Kitts and Nevis","KM":"Comoros","ST":"Sao Tome and Principe","SK":"Slovakia","KR":"South Korea","SI":"Slovenia","KP":"North Korea","KW":"Kuwait","SN":"Senegal","SM":"San Marino","SL":"Sierra Leone","SC":"Seychelles","KZ":"Kazakhstan","KY":"Cayman Islands","SG":"Singapore","SE":"Sweden","SD":"Sudan","DO":"Dominican Republic","DM":"Dominica","DJ":"Djibouti","DK":"Denmark","VG":"British Virgin Islands","DE":"Germany","YE":"Yemen","DZ":"Algeria","US":"United States","UY":"Uruguay","YT":"Mayotte","UM":"United States Minor Outlying Islands","LB":"Lebanon","LC":"Saint Lucia","LA":"Laos","TV":"Tuvalu","TW":"Taiwan","TT":"Trinidad and Tobago","TR":"Turkey","LK":"Sri Lanka","LI":"Liechtenstein","LV":"Latvia","TO":"Tonga","LT":"Lithuania","LU":"Luxembourg","LR":"Liberia","LS":"Lesotho","TH":"Thailand","TF":"French Southern Territories","TG":"Togo","TD":"Chad","TC":"Turks and Caicos Islands","LY":"Libya","VA":"Vatican","VC":"Saint Vincent and the Grenadines","AE":"United Arab Emirates","AD":"Andorra","AG":"Antigua and Barbuda","AF":"Afghanistan","AI":"Anguilla","VI":"U.S. Virgin Islands","IS":"Iceland","IR":"Iran","AM":"Armenia","AL":"Albania","AO":"Angola","AQ":"Antarctica","AS":"American Samoa","AR":"Argentina","AU":"Australia","AT":"Austria","AW":"Aruba","IN":"India","AX":"Aland Islands","AZ":"Azerbaijan","IE":"Ireland","ID":"Indonesia","UA":"Ukraine","QA":"Qatar","MZ":"Mozambique"}
export function removeCountySuffix(input) {
	const strInput = input.trim();
	if (strInput.endsWith(" County")) {
		return strInput.substr(0, strInput.length - 7);
	}

	return strInput;
}

export function convertStateToAbbr(input) {
	if (input === undefined) return input;

	const strInput = input.trim();
	if (strInput.length < 2)
		return strInput;

	if (strInput.length === 2) {
		// already abbr, check if it's valid
		const upStrInput = strInput.toUpperCase();
		return mapAbbrFullName[upStrInput] ? upStrInput : strInput;
	}

	const strStateToFind = strInput.toLowerCase().replace(/ /g, '');
	if (!(strStateToFind in mapFullNameAbbr))
		return input;

	const foundAbbr = mapFullNameAbbr[strStateToFind];
	return foundAbbr;
}

export function convertAbbStateToFull(input) {
	if (input === undefined) return input;

	const strInput = input.trim();
	if (strInput.length !== 2)
		return strInput;

	const strStateToFind = strInput.toUpperCase().replace(/ /g, '');
	if (!(strStateToFind in mapAbbrFullName))
		return input;

	const foundAbbr = mapAbbrFullName[strStateToFind];
	return foundAbbr;
}

export function dateFromDate(input) {
	return new Date(input)
}

export function isEquivalent(a, b) {
	const aProps = Object.getOwnPropertyNames(a);
	const bProps = Object.getOwnPropertyNames(b);

	if (aProps.length !== bProps.length) {
		return false;
	}

	for (let i = 0; i < aProps.length; i++) {
		const propName = aProps[i];
		if (a[propName] !== b[propName]) {
			return false;
		}
	}

	return true;
}

export const relationships = {
	civilunion: "Civil union",
	domesticpartnership: "Domestic partnership",
	reciprocalrelationship: "Registered reciprocal beneficiary relationship",
	other: "Other type of legal relationship",
}

export const documents2sign = {
	form1003: ["Form 1003", "Uniform Residential Loan Application - Fannie Mae"],
	authorization: ["Autorization", "“Third Party Authorization Form"],
	certification: ["Certification", "Certify that all the information you provided is true and complete"],
}

export const getDocType = (selectedfilename, comment, parsedData) => {
	try {
		const d = JSON.parse(parsedData)
		for (const page of d.ExtractedData) {
			if (page.docType === "manufactured home loan application") {
				return "mobilehomeloanapplication"
			}
		}
	} catch (e) {
		console.log(e)
	}

	const m = {
		'id': documents["driverlicense"].concat(["I D"]),
		"w2": documents["w2"].concat(["W2"]),
		"greencard": documents["greencard"].concat(["Green Card"]),
		"bankstatement": documents["bankstatements"].concat(["Bank Statement"]),
		"paystub": documents["paystubs"].concat(["Paystub"]),
		"form1040": documents["form1040"],
		"form1120s": documents["form1120s"],
		"form1120": documents["form1120"],
		"form1065": documents["form1065"],
	}

	for (const doc in m) {
		for (const name of m[doc]) {
			if (selectedfilename.toLowerCase().includes(name.toLowerCase()) || comment.toLowerCase().includes(name.toLowerCase()) ) {
				return doc
			}
		}
	}

	return ""
}

export const documentsList = [
	"Rental History",
	"Asset Statements",
	"Appraisal Report",
	"Bank Statements",
	"Business Tax Returns",
	"Copy of Rental/Lease Agreement",
	"Divorce Decree",
	"Drivers License",
	"Evidence of Property Insurance",
	"HOA statement",
	"Signed & Dated YTD Profit & Loss Statement with Balance Sheet",
	"Homeowners Insurance Declaration Page",
	"K-1 Statements",
	"Lease Agreement(s) for properties rented",
	"Mortgage Statement(s)",
	"Paystubs",
	"Social Security Card",
	"W-2s",
	"Permanent Resident Alien Documents",
	"Copy of the Borrower's current visa",
	"Purchase Agreement",
	"Form 1040",
	"Form 1065",
	"Form 1120S",
	"Form 1120",
	"Current mortgage statement",
	"Signed letter explaining how cash-out funds will be used",
	"Gift Letter",
	"Title Insurance Report",
]

export const documents = {
	rentalhistory: ["12 Months Rental History", "12 months cancelled checks, for current residence if renting, or 12 months bank transaction history, for direct transfers"],
	assetstatements: ["Asset Statements: 401k, IRA, Retirement accounts", "Most recent 2 months & all pages even if they are blank"],
	bankstatements: ["Bank Statements - Last 2 Months", "All bank statements for all accounts from the last 2 months. Include all numbered pages of all bank statements!", "Bank Statement"],
	businesstaxreturns: ["Business Tax Returns, Last 2 years", "Last 2 years for all businesses with 25% or more ownership. All pages and schedules."],
	businesstaxreturns1: ["Business Tax Return, Last year", "Last year tax return for all businesses with 25% or more ownership. All pages and schedules."],

	copyoflease: ["Copy of Rental/Lease Agreement", "Current rental/lease agreement if renting current residence"],
	dd214: ["DD Form 214", "Certificate of release or discharge from active duty"],
	divorcedecree: ["Divorce Decree", "Provide full divorce decree or separation agreement"],
	driverlicense: ["Drivers License", "Legible state-issued drivers license", "I D", "id."],
	propertyinsurance: ["Evidence of Property Insurance", "For all properties owned"],
	taxreturns: ["Federal Tax Returns, 2 years", "Last 2 years of federal tax returns to prove income, include all schedules"],
	taxreturns1: ["Federal Tax Return, last year", "Last year federal tax returns to prove income, include all schedules"],
	finalclosingstatements: ["Final Closing Statements", "For all properties bought in last 2 years"],
	hoastatement: ["HOA statement (if applicable)", "Most current statement"],
	ytdpnl: ["Signed & Dated YTD Profit & Loss Statement with Balance Sheet", "Signed and dated YTD Profit & Loss Statement with Balance Sheet for the last year"],
	homeownersinsuranceinfo: ["Homeowners Insurance Declaration Page", "Provide the name and contact details for your insurance agent for the subject property"],
	k1: ["K-1 Statements, last 2 years", "Most recent 2 years of all K-1s listed on tax returns"],
	k11: ["K-1 Statement, last year", "Most recent year, all K-1s listed on tax returns"],
	leaseagreements: ["Lease Agreement(s) for properties rented", "For all properties owned that are currently rented"],
	mortgagestatements: ["Mortgage Statement(s)", "Most recent for all properties owned"],
	paystubs: ["Paystubs - Received in Last 30 Days", "Last 30 days of pay stubs to prove income", "Paystub", "pay stub", "paycheck"],
	pentionstatement: ["Pension Award Letter", "Most recent statement"],
	privatemoneyloan: ["Copy of the Private Note", "Complete all fields"],
	socialsecurityaward: ["Social Security Award Letter", "Obtained from the Social Security Administration"],
	socialsecuritycard: ["Social Security Card", "Legible social security card to prove social security number"],
	w2: ["W-2s - Last 2 Years", "Last 2 years of W-2s to prove income", "W2"],
	greencard: ["Permanent Resident Alien Documents", `One of the following must be reviewed during underwriting and presented at closing in order to complete the Alien Status ID Certification Form:
    Valid alien registration card (INS I-551).
    Conditional alien registration receipt card (INS Form I-551) with a valid INS Form I-751 filing receipt (petition to remove the conditions of residency).
    Valid foreign passport which contains the reading “Processed for I-551, Temporary evidence of lawful admission for permanent residency. Valid from (date), Employment Authorized.`, "Green Card"],
	i94: ["Non-permanent Resident Alien Documents", `All non-permanent resident aliens must provide evidence of their legal presence in the U.S.
    While not mandated as required documentation, the following are examples that may assist in determining the Borrower’s legal presence in the U.S.:
    Copy of the Borrower’s current visa, or
    Copy of the Borrower’s valid I-94, or
    Copy of the Employment Authorization Document (EAD) as evidence that the borrower is authorized for employment in the U.S., or
    I-797 (Notice of Action) approval notice of an I-140 (Immigrant Petition for Alien Worker) filed by the Borrower’s employer, or
    If a Borrower has filed for permanent residency, an I-797 Receipt Notice of an I-485 (Application to Register Permanent Residence or Adjust Status).`],
	other: ["Other", "Specified manually by loan officer"],
	purchaseagreement: ["Purchase Agreement", "A legal document between the buyer and seller that outlines the terms and conditions for the sale of a property, and it is often required by the lender to assess loan eligibility and property value"],
	form1040: ["Form 1040", "Personal Tax Return"],
	form1065: ["Form 1065"],
	form1120s: ["Form 1120S"],
	form1120: ["Form 1120"],
	yeeleecommon: ["ID", "ID (Coborrower)", "Purchase Agreement", "Evidence of Insurance", "Preliminary Title report", "Real Estate Experience Proof", "Bank statement for recent two months"],
	yeeleespouse: ["Spousal Consent"],
	yeeleeentityborrower: ["Operating Agreement", "Tax ID", "Certificate of Good Standing", "Certificate of Formation", "Corporate Resolution"],
	yeeleerehabloan: ["Scope of work", "Total Cost and Breakdown", "Permit"],
	yeeleerefinance: ["Current mortgage statement"],
	yeeleecashoutrefinance: ["Signed letter explaining how cash-out funds will be used"],
	yeeleemultifamily: ["Rent roll", "Current Leases", "Borrower's Pro Forma", "Property Info: Unit mix and Sq.ft. for each unit", "Property Manager Contact Information"],
	yeeleeloanwithbroker: ["Broker Demand and ID"],
}

export function getSubaddress(address, key, typ) {
	if (typeof address.length === "undefined" || address.length === 0)
		return ""

	for (let i = 0; i < address.length; i++) {
		if (address[i].types.includes(key)) {
			return address[i][typ]
		}
	}

	return ""
}

export const streetTypeAbbreviations = {
	"alley": "aly",
	"allee": "aly",
	"ally": "aly",
	"aly": "aly",

	"anex": "anx",
	"annex": "anx",
	"annx": "anx",
	"anx": "anx",

	"arcade": "arc",
	"arc": "arc",

	"avenue": "ave",
	"av": "ave",
	"aven": "ave",
	"avn": "ave",
	"anvue": "ave",
	"ave": "ave",

	"bayou": "byu",
	"bayoo": "byu",
	"byu": "byu",

	"beach": "bch",
	"bch": "bch",

	"bend": "bnd",
	"bnd": "bnd",

	"bluff": "blf",
	"bluf": "blf",
	"blf": "blf",

	"bottom": "btm",
	"bot": "btm",
	"bottm": "btm",
	"btm": "btm",

	"boulevard": "blvd",
	"boulv": "blvd",
	"boul": "blvd",
	"blvd": "blvd",

	"branch": "br",
	"brnch": "br",
	"br": "br",

	"bridge": "brg",
	"brdge": "brg",
	"brg": "brg",

	"brook": "brk",
	"brk": "brk",

	"brooks": "brks",
	"brks": "brks",

	"burg": "bg",
	"bg": "bg",

	"burgs": "bgs",
	"bgs": "bgs",

	"bypass": "byp",
	"bypa": "byp",
	"bypas": "byp",
	"byps": "byp",
	"byp": "byp",

	"camp": "cp",
	"cmp": "cp",
	"cp": "cp",

	"canyon": "cyn",
	"canyn": "cyn",
	"cnyn": "cyn",
	"cyn": "cyn",

	"cape": "cpe",
	"cpe": "cpe",

	"causeway": "cswy",
	"causwa": "cswy",
	"cswy": "cswy",

	"center": "ctr",
	"cen": "ctr",
	"cent": "ctr",
	"centr": "ctr",
	"centre": "ctr",
	"cnter": "ctr",
	"ctr": "ctr",

	"centers": "ctrs",
	"ctrs": "ctrs",

	"circle": "cir",
	"circ": "cir",
	"circl": "cir",
	"crcl": "cir",
	"crcle": "cir",
	"cir": "cir",

	"cliff": "clf",
	"clf": "clf",

	"cliffs": "clfs",
	"clfs": "clfs",

	"club": "clb",
	"clb": "clb",

	"common": "cmn",
	"cmn": "cmn",

	"commons": "cmns",
	"cmns": "cmns",

	"corner": "cor",
	"cor": "cor",

	"corners": "cors",
	"cors": "cors",

	"course": "crse",
	"crse": "crse",

	"court": "ct",
	"ct": "ct",

	"courts": "cts",
	"cts": "cts",

	"cove": "cv",
	"cv": "cv",

	"coves": "cvs",
	"cvs": "cvs",

	"cr": "county road",
	"county road": "county road",

	"creek": "crk",
	"crk": "crk",

	"crescent": "cres",
	"crsent": "cres",
	"crsnt": "cres",
	"cres": "cres",

	"crest": "crst",
	"crst": "crst",

	"crossing": "xing",
	"crssing": "xing",
	"xing": "xing",

	"crossroad": "xrd",
	"xrd": "xrd",

	"crossroads": "xrds",
	"xrds": "xrds",

	"curve": "curv",
	"curv": "curv",

	"dale": "dl",
	"dl": "dl",

	"dam": "dm",
	"dm": "dm",

	"divide": "dv",
	"div": "dv",
	"dvd": "dv",
	"dv": "dv",

	"drive": "dr",
	"driv": "dr",
	"drv": "dr",
	"dr": "dr",

	"drives": "drs",
	"drs": "drs",

	"estate": "est",
	"est": "est",

	"estates": "ests",
	"ests": "ests",

	"expressway": "expy",
	"expr": "expy",
	"express": "expy",
	"expw": "expy",
	"expy": "expy",

	"extension": "ext",
	"extn": "ext",
	"extnsn": "ext",
	"ext": "ext",

	"fall": "fall",

	"falls": "fls",
	"fls": "fls",

	"ferry": "fry",
	"frry": "fry",
	"fry": "fry",

	"field": "fld",
	"fld": "fld",

	"fields": "flds",
	"flds": "flds",

	"flat": "flt",
	"flt": "flt",

	"flats": "flts",
	"flts": "flts",

	"ford": "frd",
	"frd": "frd",

	"fords": "frds",
	"frds": "frds",

	"forest": "frst",
	"frst": "frst",

	"forge": "frg",
	"forg": "frg",
	"frg": "frg",

	"forges": "frgs",
	"frgs": "frgs",

	"fork": "frk",
	"frk": "frk",

	"fort": "ft",
	"frt": "ft",
	"ft": "ft",

	"freeway": "fwy",
	"freewy": "fwy",
	"frway": "fwy",
	"frwy": "fwy",
	"fwy": "fwy",

	"garden": "gdn",
	"gardn": "gdn",
	"grden": "gdn",
	"grdn": "gdn",
	"gdn": "gdn",

	"gardens": "gdns",
	"grdns": "gdns",
	"gdns": "gdns",

	"gateway": "gtwy",
	"gatewy": "gtwy",
	"gatway": "gtwy",
	"gtway": "gtwy",
	"gtwy": "gtwy",

	"glen": "gln",
	"gln": "gln",

	"glens": "glns",
	"glns": "glns",

	"green": "grn",
	"grn": "grn",

	"greens": "grns",
	"grns": "grns",

	"grove": "grv",
	"grov": "grv",
	"grv": "grv",

	"harbor": "hbr",
	"harb": "hbr",
	"harbr": "hbr",
	"hrbr": "hbr",
	"hbr": "hbr",

	"harbors": "hbrs",
	"hbrs": "hbrs",

	"haven": "hvn",
	"hvn": "hvn",

	"heights": "hts",
	"ht": "hts",
	"hts": "hts",

	"highway": "hwy",
	"highwy": "hwy",
	"hiway": "hwy",
	"hiwy": "hwy",
	"hway": "hwy",
	"hwy": "hwy",

	"hill": "hl",
	"hl": "hl",

	"hills": "hls",
	"hls": "hls",

	"hollow": "holw",
	"hllw": "holw",
	"hollows": "holw",
	"holws": "holw",
	"holw": "holw",

	"hodor": "hodor",

	"inlet": "inlt",
	"inlt": "inlt",

	"island": "is",
	"islnd": "is",
	"is": "is",

	"isle": "isle",
	"isles": "isle",

	"junction": "jct",
	"jction": "jct",
	"jctn": "jct",
	"junctn": "jct",
	"juncton": "jct",
	"jct": "jct",

	"junctions": "jcts",
	"jctns": "jcts",
	"jcts": "jcts",

	"key": "ky",
	"ky": "ky",

	"keys": "kys",
	"kys": "kys",

	"knoll": "knl",
	"knol": "knl",
	"knl": "knl",

	"knolls": "knls",
	"knls": "knls",

	"lake": "lk",
	"lk": "lk",

	"lakes": "lks",
	"lks": "lks",

	"land": "land",

	"landing": "lndg",
	"lndng": "lndg",
	"lndg": "lndg",

	"lane": "ln",
	"ln": "ln",

	"light": "lgt",
	"lgt": "lgt",

	"lights": "lgts",
	"lgts": "lgts",

	"loaf": "lf",
	"lf": "lf",

	"lock": "lck",
	"lck": "lck",

	"locks": "lcks",
	"lcks": "lcks",

	"lodge": "ldg",
	"ldge": "ldg",
	"lodg": "ldg",
	"ldg": "ldg",

	"loop": "loop",
	"loops": "loop",

	"mall": "mall",

	"manor": "mnr",
	"mnr": "mnr",

	"manors": "mnrs",
	"mnrs": "mnrs",

	// Accoding to that table...:
	// "meadow": "mdw",
	// "mdw": "mdw",

	// But on the following line...
	"meadows": "mdws",
	"mdw": "mdws",
	"meadow": "mdws",
	"medows": "mdws",
	"mdws": "mdws",

	"mews": "mews",

	"mill": "ml",
	"ml": "ml",

	"mission": "msn",
	"misn": "msn",
	"msn": "msn",

	"motorway": "mtwy",
	"mtwy": "mtwy",

	"mountain": "mtn",
	"mntain": "mtn",
	"mt": "mtn",
	"mountin": "mtn",
	"mtin": "mtn",
	"mtn": "mtn",

	"mountains": "mtns",
	"mtns": "mtns",

	"neck": "nck",
	"nck": "nck",

	"orchard": "orch",
	"orchrd": "orch",
	"orch": "orch",

	"oval": "ovl",
	"ovl": "ovl",

	"overpass": "opas",
	"opas": "opas",

	"park": "park",
	"parks": "park",
	"prk": "park",

	"parkway": "pkwy",
	"parkwy": "pkwy",
	"pkway": "pkwy",
	"pky": "pkwy",
	"parkways": "pkwy",
	"pkwys": "pkwy",
	"pkwy": "pkwy",

	"pass": "pass",

	"passage": "psge",
	"psge": "psge",

	"path": "path",
	"paths": "paths",

	"pike": "pike",
	"pikes": "pike",

	"pine": "pne",
	"pne": "pne",

	"pines": "pnes",
	"pnes": "pnes",

	"place": "pl",
	"pl": "pl",

	"plain": "pln",
	"pln": "pln",

	"plains": "plns",
	"plns": "plns",

	"plaza": "plz",
	"plza": "plz",
	"plz": "plz",

	"point": "pt",
	"pt": "pt",

	"points": "pts",
	"pts": "pts",

	"port": "prt",
	"prt": "prt",

	"ports": "prts",
	"prts": "prts",

	"prarie": "pr",
	"prr": "pr",
	"pr": "pr",

	"radial": "radl",
	"rad": "radl",
	"radiel": "radl",
	"radl": "radl",

	"ramp": "ramp",

	"ranch": "rnch",
	"ranches": "rnch",
	"rnchs": "rnch",
	"rnch": "rnch",

	"rapid": "rpd",
	"rpd": "rpd",

	"ridge": "rdg",
	"rdge": "rdg",
	"rdg": "rdg",

	"rest": "rst",
	"rst": "rst",

	"ridges": "rdgs",
	"rdgs": "rdgs",

	"road": "road",
	"rd": "rd",

	"route": "rte",
	"rte": "rte",

	"row": "row",

	"rue": "rue",

	"run": "run",

	"shoal": "shl",
	"shl": "shl",

	"shoals": "shls",
	"shls": "shls",

	"shore": "shr",
	"shores": "shr",
	"shrs": "shr",
	"shr": "shr",

	"skyway": "skwy",

	"spring": "spg",
	"spng": "spg",
	"sprng": "spg",
	"spg": "spg",

	"springs": "spgs",
	"spngs": "spgs",
	"sprngs": "spgs",
	"spgs": "spgs",

	"spur": "spur",
	"spurs": "spur",

	"square": "sq",
	"sqr": "sq",
	"sqre": "sq",
	"squ": "sq",
	"sq": "sq",

	"squares": "sqs",
	"sqrs": "sqs",
	"sqs": "sqs",

	"station": "sta",
	"statn": "sta",
	"stn": "sta",
	"sta": "sta",

	"stravenue": "stra",
	"strav": "stra",
	"straven": "stra",
	"stravn": "stra",
	"strvn": "stra",
	"strvnue": "stra",
	"stra": "stra",

	"stream": "strm",
	"streme": "strm",
	"strm": "strm",

	"street": "st",
	"strt": "st",
	"str": "st",
	"st": "st",

	"streets": "sts",

	"summit": "smt",
	"sumit": "smt",
	"sumitt": "smt",
	"smt": "smt",

	"terrace": "ter",
	"terr": "ter",
	"ter": "ter",

	"throughway": "trwy",
	"trwy": "trwy",

	"trace": "trce",
	"traces": "trce",
	"trce": "trce",

	"track": "trak",
	"tracks": "trak",
	"trk": "trak",
	"trks": "trak",
	"trak": "trak",

	"trailer": "trlr",
	"trlrs": "trlr",
	"trlr": "trlr",

	"tunnel": "tunl",
	"tunls": "tunl",
	"tunnels": "tunl",
	"tunnl": "tunl",
	"tunl": "tunl",

	"turnpike": "tpke",
	"trnp": "tpke",
	"turnpk": "tpke",
	"tpke": "tpke",

	"underpass": "upas",
	"upas": "upas",

	"union": "un",
	"un": "un",

	"valley": "vly",
	"vally": "vly",
	"vlly": "vly",
	"vly": "vly",

	"valleys": "vlys",
	"vlys": "vlys",

	"viaduct": "via",
	"vdct": "via",
	"viadct": "via",
	"via": "via",

	"view": "vw",
	"vw": "vw",

	"views": "vws",
	"vws": "vws",

	"village": "vlg",
	"villag": "vlg",
	"vill": "vlg",
	"villg": "vlg",
	"villiage": "vlg",
	"vlg": "vlg",

	"villages": "vlgs",
	"vlgs": "vlgs",

	"ville": "vl",
	"vl": "vl",

	"vista": "vis",
	"vist": "vis",
	"vst": "vis",
	"vsta": "vis",
	"vis": "vis",

	"walk": "walk",
	"walks": "walk",

	"wall": "wall",

	"way": "way",
	"wy": "way",

	"ways": "ways",

	"well": "wl",
	"wl": "wl",

	"wells": "wls",
	"wls": "wls",
}

export const SuiteTypeAbbreviations = {
	"apartment": "apt",
	"#": "apt",
	"apt": "apt",

	"building": "bldg",
	"bldg": "bldg",

	"floor": "fl",
	"fl": "fl",

	"suite": "ste",
	"ste": "ste",

	"unit": "unit",

	"room": "rm",
	"rm": "rm",

	"department": "dept",
	"dept": "dept",

	"box": "box",
}

export const cardinalDirectionAbbreviations = {
	"north": "n",
	"n": "n",
	"northwest": "nw",
	"nw": "nw",
	"northeast": "ne",
	"ne": "ne",
	"south": "s",
	"s": "s",
	"southwest": "sw",
	"sw": "sw",
	"southeast": "se",
	"se": "se",
	"east": "e",
	"e": "e",
	"west": "w",
	"w": "w",
}

export const streetsuffixes = Object.keys(streetTypeAbbreviations).map(a => a.toUpperCase())

export const remapSuffixes = { TERRACE: "TER" }

export const prefixes = ["W", "E", "N", "S", "SW", "SE", "NW", "NE"]
export function decommaizeNumeric(v) {
	const n = v.replace(/[^0-9-]/g, '');
	if (n === "")
		return n

	return parseInt(n)
}

export function commaize(v) {
	if (null === v || typeof v === "undefined" || v === "") {
		return ""
	}

	try {
		v = v.toString()
		let input = v.replace(/[^0-9-.]/g, '');

		if (input === "") {
			return ""
		}

		input = parseInt(input)

		input = input.toString()
		let output = ""
		while (true) {
			if (input.length <= 3) {
				output = input + output
				break
			}
			const right = input.substr(-3)
			const left = input.substr(0, input.length - 3)
			input = left
			output = "," + right + output
		}

		return output
	} catch (error) {
		return v
	}
}

export function commaizeFloat(v) {
	if (null === v || typeof v === "undefined" || v === "") {
		return ""
	}

	v = v.toString()
	let minus = ""
	if (v.charAt(0) === '-') {
		minus = '-'
		v = v.substring(1, v.length)
	}

	const parts = v.split('.')
	const input = parts[0].replace(/[^0-9-]/g, '');

	parts[0] = commaize(input)

	return minus + parts.join('.')
}

export function splitByCapitalLetter(str) {
	if (typeof str !== 'string') {
		return str
	}
	return str.split(/(?=[A-Z])/).join(' ');
}

export function divideStringByCapitalLetter(str) {
	// Use a regular expression to find positions where a space should be inserted:
	// Look for sequences where an uppercase letter is either preceded by a lowercase letter
	// or followed by a lowercase letter, and insert a space before the uppercase letter.
	return str.replace(/([a-z])([A-Z])|([A-Z])([A-Z][a-z])/g, '$1$3 $2$4');
}

const LENDER_DISPLAY_NAME_OVERRIDES = {
	amwest: "AmWest",
	itrust: "iTrust",
	uhm: "Union Home Mortgage",
};

function getLenderDisplayOverride(lender) {
	if (!lender) {
		return null;
	}
	const normalized = lender.trim().replace(/\s+/g, "").toLowerCase();
	return LENDER_DISPLAY_NAME_OVERRIDES[normalized] != null
		? LENDER_DISPLAY_NAME_OVERRIDES[normalized]
		: null;
}

export function formatLenderDisplayName(lender) {
	if (!lender) {
		return "";
	}
	const trimmed = lender.trim();
	// Whole-name override, e.g. "iTrust" -> "iTrust", "amwest" -> "AmWest".
	const override = getLenderDisplayOverride(trimmed);
	if (override) {
		return override;
	}
	// Prefix override: channel variants like "iTrustWholesale" / "iTrust Retail"
	// should keep the lender name intact and only space-separate the suffix,
	// instead of letting divideStringByCapitalLetter break "iTrust" into "i Trust".
	const noSpace = trimmed.replace(/\s+/g, "");
	const lowerNoSpace = noSpace.toLowerCase();
	for (const key of Object.keys(LENDER_DISPLAY_NAME_OVERRIDES)) {
		if (lowerNoSpace.length <= key.length || !lowerNoSpace.startsWith(key)) {
			continue;
		}
		// Only treat it as a prefix match at a real word boundary (the suffix
		// starts with an uppercase letter or digit), so unrelated names that
		// merely share the prefix are left untouched.
		if (!/[A-Z0-9]/.test(noSpace.charAt(key.length))) {
			continue;
		}
		const suffix = divideStringByCapitalLetter(noSpace.slice(key.length)).trim();
		return suffix
			? `${LENDER_DISPLAY_NAME_OVERRIDES[key]} ${suffix}`
			: LENDER_DISPLAY_NAME_OVERRIDES[key];
	}
	return divideStringByCapitalLetter(trimmed);
}
// Acronyms that start a pricing-adjustment key. Two acronyms run together read
// as one word otherwise: DSCRCLTVAdjustment came out "DSCRCLTV Adjustment"
// because the regex below can only see the boundary before a capitalized word.
const LEADING_ACRONYMS = ['DSCR', 'FICO', 'CLTV', 'LTV', 'DTI', 'ARM', 'APR'];
export function divideStringByConsecutiveCapitalLetter(str) {
	// Not `str ?? ''`: this file is symlinked into web/admin, whose react-scripts
	// is old enough that babel leaves nullish coalescing for webpack to choke on.
	let s = String(str === null || str === undefined ? '' : str);
	for (const acronym of LEADING_ACRONYMS) {
		// \b only matches at the start here: mid-word runs like
		// "HighBalanceARMAdjustment" are already split by the regex below.
		s = s.replace(new RegExp(`\\b${acronym}(?=[A-Z])`, 'g'), `${acronym} `);
	}
	return s.replace(/([a-z])([A-Z])|([A-Z]+)([A-Z][a-z])/g, '$1$3 $2$4');
}
export function capitalize(v) {
	if (v === null) {
		return ""
	}

	const parts = v.split(' ')
	const newparts = []
	parts.forEach(a => {
		newparts.push(a.charAt(0).toUpperCase() + a.slice(1).toLowerCase())
	})

	return newparts.join(' ')
}

export function unCamelCase(str) {
	if (str === null) {
		return ""
	}

	const out = []
	out.push(str.charAt(0))
	let digit = false
	for (let i = 1; i < str.length; i++) {
		const code = str.charCodeAt(i)

		if (code >= 48 && code <= 57) {
			if (!digit) out.push(" ")
			out.push(str.charAt(i))
			digit = true
			continue
		}

		if (code >= 65 && code <= 90) {
			digit = false
			out.push(" ")
			out.push(str.charAt(i))
			continue
		}

		out.push(str.charAt(i))
		digit = false
	}

	return out.join('')
}

export function loadPasswordCheck(callback) {
	const existingScript = document.getElementById('zxcvbn');

	if (!existingScript) {
		const script = document.createElement('script');
		script.src = '/js/zxcvbn.js';
		script.id = 'zxcvbn';
		document.body.appendChild(script);

		script.onload = () => {
			if (callback) callback();
		};
	}

	if (existingScript && callback) callback();
};

export function positionToStatus(pos) {
	let status = "Invited"
	if (pos !== -1) {
		status = "Accepted"
		if (pos >= 0 && pos < 13) {
			status = "Started"
		} else {
			if (pos >= 13 && pos < 27) {
				status = "Prequalified"
			} else {
				status = "Filled Out"
			}
		}
	}

	return status
}

export const prefillLimit = 13

export function timeGoToJS(dat) {
	let r = /([0-9]{4})-([0-9]{2})-([0-9]{2}) ([0-9:]{8})(?:[0-9.]*) ([0-9-+]{5}) ([A-Z]{3})/i

	let newdat = dat.replace(r, (match, group1, group2, group3, group4, group5, group6) => {

		return group1 + "/" + group2 + "/" + group3 + " " + group4 + " " + group6
	});

	return newdat
}

export function timeGoToDateJS(dat) {
	const r = /([0-9]{4})-([0-9]{2})-([0-9]{2}) ([0-9:]{8})(?:[0-9.]*) ([0-9-+]{5}) ([A-Z]{3})/i

	const newdat = dat.replace(r, (match, group1, group2, group3, group4, group5, group6) => {
		return group1 + "/" + group2 + "/" + group3
	});

	return newdat
}

export const checkSession = (onSessionExists, onNoSession) => {
	const token = window.sessionStorage.getItem("ZeitroA");
	if (token === null) {
		console.log("not authenticated");
		onNoSession();
		return;
	}
	fetch(window.location.origin + "/auth/refresh", {
		cache: 'no-cache',
		method: 'POST',
		body: "",
		headers: {
			Authorization: "Bearer " + token,
			Cache: "no-cache"
		},
	}).then(response => {
		if (!response.ok) {
			sessionStorage.removeItem("ZeitroA")
			onNoSession()
		} else {
			response.json().then(js => {
				if (js.Status !== "OK") {
					sessionStorage.removeItem("ZeitroA")
					onNoSession()
				} else {
					onSessionExists()
					sessionStorage.setItem("ZeitroA", js.Token)
				}
			})
		}
	}).catch(error => {
		sessionStorage.removeItem("ZeitroA")
		onNoSession()
	})
}

export const othersouresofincome = [
	// #######   deprecated and modified some items to match new 1003 URLA form section 1e options    ###################
	// ["AccessoryUnitIncome", "Accessory Unit Income", "The amount of rental income from a 1-unit property with an accessory dwelling unit."],
	["Alimony", "Alimony", "Alimony (also called maintenance or spousal support) is financial support to a spouse from the other spouse after marital separation or from the ex-spouse upon divorce."],
	["AutomobileAllowance", "Automobile Allowance", "Compensation for automobile-related expenses incurred"],
	["BoarderIncome", "Boarder Income", "Income received by the borrower from an occupant of a portion of the subject property"],
	["CapitalGains", "Capital Gains", "Amount from the sale of a capital asset at a higher value than the purchase price"],
	["ChildSupport", "Child Support", "Child support (or child maintenance) is an ongoing, periodic payment made by a parent for the financial benefit of a child following the end of a marriage or other relationship."],
	// ["ContractBasis", "Contract Work", "Income received on a contract or per job basis. Recipients are classified by employers as independent contractors and not considered employees."],
	// ["DefinedContributionPlan", "Defined Contribution Plan", "A plan which provides each participant an individual account for benefits based solely on the amount contributed to the participant's account as well as any income, expenses, gains and losses. Typical examples are Individual Retirement Account (IRA) and 401k."],
	["Disability", "Disability", "Income from disability coverage for a condition that prevents a person from working"],
	// ["EmploymentRelatedAccount", "Employee Related Account", "An account obtained by the borrower through employment sources used to calculate a potential income stream for qualification purposes as per investor guidelines"],
	["FosterCare", "Foster Care", "An allowance provided by a social welfare jurisdication for the care of foster children"],
	// ["HousingAllowance", "Housing", "Compensation for basic living expenses for certain employment situations"],
	["HousingParsonage", "Housing or Parsonage", "Income received by the borrower from a parsonage (a house of worship) owned by the church"],
	["DividendsInterest", "Interest and Dividends", "Amount from distributions from a company's earnings to a shareholder in the form of cash payments, stock, and income earned from interest-bearing financial accounts by issuer of account"],
	// ["HousingChoiceVoucherProgram", "Housing Choice Voucher", "Public assistance income in the form of a housing subsidy paid by the government to the landlord on behalf of the borrower"],
	// ["MilitaryBasePay", "Military Base Pay", ""],
	// ["MilitaryClothesAllowance", "Military Clothes Allowance", ""],
	// ["MilitaryCombatPay", "Military Combat Pay", ""],
	// ["MilitaryFlightPay", "Military Flight Pay", ""],
	// ["MilitaryHazardPay", "Military Hazard Pay", ""],
	// ["MilitaryOverseasPay", "Military Overseas Pay", ""],
	// ["MilitaryPropPay", "Military Prop Pay", ""],
	// ["MilitaryQuartersAllowance", "Military Quarters Allowance", ""],
	// ["MilitaryRationsAllowance", "Military Rations Allowance", ""],
	// ["MilitaryVariableHousingAllowance", "Military Variable Housing Allowance", ""],
	["MortgageCreditCertificate", "Mortgage Credit Certificate", "A tax credit granted by government jurisdictions to help first-time homebuyers offset a portion of the interest on a new mortgage."],
	["MortgageDifferential", "Mortgage Differential Payments", "Income used when an employer subsidizes and employees mortgage payments by paying all or part of the interest differential between the employees present and proposed mortgage payments"],
	// ["NonBorrowerContribution", "Non Borrower Contribution", ""],
	// ["NonBorrowerHouseholdIncome", "Non Borrower Household Income", "The amount of income from a non-borrower household member that may be considered as a compensating factor for community lending loans when the income is greater than or equal to a percentage of the borrower’s income per investor guidelines"],
	["NotesReceivableInstallment", "Notes Receivable", "Income received from the payment of a debt owed to the borrower"],
	["PublicAssistance", "Public Assistance", "Amount paid to borrower by federal, state or local public assistance program"],
	["Retirement", "Retirement", ""],
	// ["Pension", "Pension Income", "Periodic amount paid by employer to persons who have retired from employer after attaining necessary term of service and other attributes."],
	["Royalties", "Royalty Payments", "A payment to an owner for the use of property, patents, copyrighted works, franchises or natural resources"],
	["SeparateMaintenance", "Separate Maintenance", "Money paid by one previously married person to the other for support if they are no longer living as Husband and Wife. Also known as Separate Support"],
	["SocialSecurity", "Social Security", "In the US, amount paid to recipients of OASI (Old Age and Survivors Insurance)"],
	// ["TemporaryLeave", "Temporary Leave Income", "The amount of income available to the borrower during a period of approved absence"],
	// ["TipIncome", "Tip Income", "The amount of income earned through gratuity that is not part of a regular wage"],
	["Trust", "Trust", "Income the borrower receives as the beneficiary of a trust"],
	["Unemployment", "Unemployment Benefits", "Amount paid or payable to borrower from state or Federal unemployment insurance program"],
	// ["VABenefitsNonEducational", "VA Benefits Income", "Dollar amount of VA Benefits excluding education benefits available to a veteran borrower"],
	["VACompensation", "VA Compensation", "Amount paid to a veteran borrower for service-connected disabilities"],
	["Other", "Other", "Please enter the income type"],
]

export const bankaccounttypes = [
	["CheckingAccount", "Checking", "Transaction account with a financial institution. Accounts purpose is to effect transfer of owners funds to others by various methods (e.g., check, EFT, ACH, draft). Technical name is demand deposit account (DDA)."],
	["SavingsAccount", "Savings", "Interest-paying account with a financial institution whose main purpose is to earn interest on owners funds held therein. This is NOT a demand deposit account."],
	["MoneyMarket", "Money Market", "Mutual fund that allows individuals to participate in managed investments in short-term debt securities, such as certificates of deposit and Treasury bills."],
	["CertificateOfDeposit", "Certificate of Deposit", "Certificates issued by financial institutions with a stated term or interest rate, and with a set maturity date. The bank pays the holder in due course at maturity. Early withdrawal subject to penalty. Considered liquid."],
	["Retirement", "Retirement", ""],
	["Bonds", "Bonds", ""],
	["Stocks", "Stocks", ""],
	// #######   added some items below to match new 1003 URLA form section 2a options    ###################
	["StockOptions", "Stock Options", ""],
	["BridgeLoanProceeds", "Bridge Loan Proceeds", ""],
	["IndividualDevelopmentAccount", "Individual Development Account", ""],
	["TrustAccount", "Trust Account", ""],
	["CashValueLifeInsurance", "Cash Value of Life Insurance", ""],
	["MutualFund", "Mutual Fund", ""],
]

export const brokerageaccounttypes = [
	["Stock", "Stocks", "Financial instrument evidencing an ownership interest in entity that issued the stock. Typical valuation method is Market."],
	["Bond", "Bonds", "An interest-bearing certificate of debt with maturity date. An obligation of issuing entity. Typical valuation is face value (e.g., $1,000 denomination) & market (e.g., value of 4% bond when yields are 6%)"],
	["StockOptions", "Stock Options", "Option given by a company to an employee to buy stock in the company at a discount or at a stated fixed price."],
]

export const otherassetsandcredits = [
	// #######   deprecated some items to match new 1003 URLA form section 2b options    ###################
	// ["BridgeLoanNotDeposited", "Bridge Loan Not Deposited", "Proceeds of a loan (secured by borrowers real property) to provide homebuyer with funds for down payment and closing costs on a new home before selling the collateral property which have not yet been deposited to borrowers accounts or included with other assets disclosed"],
	// ["CashOnHand", "Cash On Hand", "Currency physically possessed by borrower, not deposited in any financial institution"],
	// ["IndividualDevelopmentAccount", "Individual Development Account", "A matching funds savings account that helps people save for the purchase of real estate"],
	// ["PendingNetSaleProceedsFromRealEstateAssets", "Pending Net Sale Proceeds From Real Estate Asset", "Estimated net cash proceeds (sales price - obligations) from anticipated sale of borrowers real estate assets"],
	// ["ProceedsFromSaleOfNonRealEstateAsset", "Proceeds From Sale Of Non Real Estate Asset", "Amount received by borrower from sale of personal property"],
	// ["ProceedsFromSecuredLoan", "Proceeds From Secured Loan", "Proceeds from a loan secured by borrowers assets"],
	// ["ProceedsFromUnsecuredLoan", "Proceeds From Unsecured Loan", "Proceeds from a loan not backed by any collateral"],
	// ["TrustAccount", "Trust Account", "Fiduciary relationship where legal title to a property is transferred to a trustee with the intention the property be administered by the trustee for benefit of the beneficiary, who holds equitable title to such property"],

	// ["EarnestMoney", "Earnest Money", "A deposit made as a show of good faith by buyer to bind the conditions of a sale of real estate"],
	// ["EmployerAssistedHousing", "Employer Assisted Housing", "Funds provided to borrower by employer to offset some of the initial or ongoing costs of borrowers home"],
	// ["LeasePurchaseFund", "Lease PurchaseFund", "Under a lease/purchase arrangement, owner of real estate agrees to credit some portion of rent towards down payment. This is the accumulated amount of such credits reflected at closing"],
	// ["RelocationFunds", "Relocation Funds", "Funds provided to relocating borrower (usually by employer) to offset some of the initial or ongoing costs of borrowers home at the new location"],
	// ["SweatEquity", "Sweat Equity", "Buyer/borrower agrees with owner (who is usually also builder/re-habber) that work done by Buyer/borrower to help complete the property will be credited as having specific value and will be done in lieu of some portion of the cash purchase price"],
	// ["TradeEquityFromPropertySwap", "Trade Equity From Property Swap", "Equity that results from a property purchaser giving his or her existing real property as trade as all or part of the down payment for the property that is being purchased"],
	// ["Other", "Other type of asset", ""],

	// #######   updated items to match new 1003 URLA form section 2b options    ###################
	["ProceedsFromRealEstatePropertyToBeSoldOnOrBeforeClosing", "Proceeds from Real Estate Property to be sold on or before closing", ""],
	["ProceedsFromSaleOfNonRealEstateAsset", "Proceeds from Sale of Non-Real Estate Asset", ""],
	["SecuredBorrowedFunds", "Secured Borrowed Funds", ""],
	["UnsecuredBorrowedFunds", "Unsecured Borrowed Funds", ""],
	["Other", "Other type of asset", ""],
	["EarnestMoney", "Earnest Money", ""],
	["EmployerAssistance", "Employer Assistance", ""],
	["LotEquity", "Lot Equity", ""],
	["RelocationFunds", "Relocation Funds", ""],
	["RentCredit", "Rent Credit", ""],
	["SweatEquity", "Sweat Equity", ""],
	["TradeEquity", "Trade Equity", ""],
]

export const fundssourcetype = [
	// #######   deprecated and modified some items to match new 1003 URLA form section 4d options    ###################
	["CommunityNonProfit", "Community Nonprofit", "A nonprofit organization with no religious affiliation"],
	["Employer", "Employer", "Party who provides income to the borrower in exchange for work"],
	["FederalAgency", "Federal Agency", "A department of the national government responsible for the oversight and administration of a specific function"],
	// ["Institutional", "Institutional", ""],
	["LocalAgency", "Local Agency", "An administrative authority over areas that are smaller than a state, for example, counties, cities, or townships"],
	["StateAgency", "State Agency", "An administrative authority one of the fifty states making up the United States"],
	["Lender", "Lender", "Party funding the mortgage loan"],
	// ["NonParentRelative", "Non Parent Relative", "An individual related to the borrower that is not the borrower's legal parent or guardian"],
	// ["Parent", "Parent", "Borrower's mother or father"],
	["Relative", "Relative", "An individual related to the borrower by blood, marriage, adoption, or legal guardianship"],
	["ReligiousNonProfit", "Religious Nonprofit", "A nonprofit organization affiliated with a religion"],
	["UnmarriedPartner", "Unmarried Partner", "Fiancé, fiancée, registered domestic partnership, civil union partner, or registered reciprocal beneficiary"],
	// ["UnrelatedFriend", "Unrelated Friend", "Party having a non-familial relationship to the borrower"],
	["Other", "Other", ""],
]

/*
AssetType:
	- Bond                 # An interest-bearing certificate of debt with maturity date. An obligation of issuing entity. Typical valuation is face value (e.g., $1,000 denomination) & market (e.g., value of 4% bond when yields are 6%).
	- BridgeLoanNotDeposited # Proceeds of a loan (secured by borrowers real property) to provide homebuyer with funds for down payment and closing costs on a new home before selling the collateral property which have not yet been deposited to borrowers accounts or included with other assets disclosed.
	- CashOnHand           # Currency physically possessed by borrower, not deposited in any financial institution.
	- CertificateOfDepositTimeDeposit # Certificates issued by financial institutions with a stated term or interest rate, and with a set maturity date. The bank pays the holder in due course at maturity. Early withdrawal subject to penalty. Considered liquid.
	- CheckingAccount      # Transaction account with a financial institution. Accounts purpose is to effect transfer of owners funds to others by various methods (e.g., check, EFT, ACH, draft). Technical name is demand deposit account (DDA).
	- IndividualDevelopmentAccount # A matching funds savings account that helps people save for the purchase of real estate.
	- LifeInsurance        # A life insurance policy with a value or investment component. Details of amounts for each policy or Accumulated investment cash value of life insurance policy, net of any loans against that amount. Detail of amounts for each policy.
	- MoneyMarketFund      # Mutual fund that allows individuals to participate in managed investments in short-term debt securities, such as certificates of deposit and Treasury bills.
	- MutualFund           # Financial entity that invests its shareholders funds in stocks and bonds of other entities with the objective of obtaining a return on its shareholders investment.
	- Other
	- PendingNetSaleProceedsFromRealEstateAssets # Estimated net cash proceeds (sales price - obligations) from anticipated sale of borrowers real estate assets.
	- ProceedsFromSaleOfNonRealEstateAsset # Amount received by borrower from sale of personal property.
	- ProceedsFromSecuredLoan # Proceeds from a loan secured by borrowers assets.
	- ProceedsFromUnsecuredLoan # Proceeds from a loan not backed by any collateral.
	- RetirementFund       # 401Ks, IRAs, etc. controlled by borrower (vested) valued at market.
	- SavingsAccount       # Interest-paying account with a financial institution whose main purpose is to earn interest on owners funds held therein. This is NOT a demand deposit account.
	- Stock                # Financial instrument evidencing an ownership interest in entity that issued the stock. Typical valuation method is Market.
	- StockOptions         # Option given by a company to an employee to buy stock in the company at a discount or at a stated fixed price.
	- TrustAccount         # Fiduciary relationship where legal title to a property is transferred to a trustee with the intention the property be administered by the trustee for benefit of the beneficiary, who holds equitable title to such property.
*/

export const downpaymentsources = [
	{ id: "Checking", name: "Checking" },
	{ id: "Savings", name: "Savings" },
	{ id: "Certificate of Deposit", name: "Certificate of Deposit" },
	{ id: "Money Market", name: "Money Market" },
	{ id: "Mutual funds", name: "Mutual funds" },
	{ id: "Publicly traded stocks", name: "Publicly traded stocks" },
	{ id: "Stock Options", name: "Stock Options" },
	{ id: "Bonds", name: "Bonds" },
	{ id: "Bridge Loan Proceeds", name: "Bridge Loan Proceeds" },
	{ id: "Annuities", name: "Annuities" },
	{ id: "Trust Account", name: "Trust Account" },
	{ id: "Individual Development	Account (e.g. 401k or IRA)", name: "Individual Development Account  (e.g., 401k, IRA)" },
	{ id: "Cash Value of Life Insurance (used for the transaction)", name: "Cash Value of Life Insurance (used for the transaction)" },
	{ id: "Other", name: "Other" }
]

export const sourcesofdownpayment = [
	"Checking",
	"Savings",
	"Certificate of Deposit",
	"Money Market",
	"Mutual funds",
	"Publicly traded stocks",
	"Stock Options",
	"Bonds",
	"Bridge Loan Proceeds",
	"Annuities",
	"Trust Account",
	"Individual Development	Account  (e.g., 401k, IRA)",
	"Cash Value of Life Insurance (used for the transaction)",
]

export const mannerthetitleheld = [
	"Community Property",
	"Individual",
	"Joint Tenants With Right Of Survivorship",
	"Life Estate",
	"Tenants in Common",
	"Tenancy by Entirety",
	"To be Decided in Escrow",
	"Trust",
]

export const stageToNumber = {
	start: 0,
	personal: 2,
	property: 4,
	income: 6,
	assets: 10,
	liabilities: 15,
	prequal: 24,
	choice: 25,

	transaction: 26,
	declarations: 27,
	end: 31
}

export const stageToNumberApplication = {
	start: 0,
	applicant: 2,
	residence: 3,
	property: 4,
	income: 5,
	assets: 7,
	realestate: 8,
	liabilities: 9,
	propertymoney: 10,
	finances: 11,
	creditcheck: 12,
	coborrower: 13,
	overview: 24,
	rates: 25,
	prequalletter: 26,
	documents: 27,
	tasks: 28,
	closing: 30,
}

export const stageToNumberRE = {
	start: 0,
	personal: 2,
	property: 4,
	income: 6,
	assets: 10,
	liabilities: 15,
	prequal: 24,
	choice: 25,
	end: 26,
}

export function getClosedInterestPaid(rate, loansize, termyears, spanyears) {
	const termmonths = termyears * 12
	const spanmonths = spanyears * 12
	const monthlyrate = rate / 12.0
	const expn = Math.pow(1 + monthlyrate, termmonths)

	let payment = loansize * monthlyrate * expn / (expn - 1)
	payment = (Math.round(payment * 100) / 100)

	const accumulatedinterest = (loansize * monthlyrate - payment) *
		(Math.pow(1 + monthlyrate, spanmonths) - 1) / monthlyrate +
		spanmonths * payment

	return accumulatedinterest
}

export const sorts = {
	selectbyrate: "Rate",
	selectbyapr: "APR",
	selectbyinterestterm: "Total Interest over XXX years",
	selectbyinteresttotal: "Interest over loan term",
	selectbymonthlypayment: "Monthly Payment",
	selectbyclosingcosts: "Closing costs",
	selectbyadvanced: "Advanced",
}

export const typeoptions = [
	{ name: 'ARM 5/1', id: "arm51", cliff: 5 },
	{ name: 'ARM 7/1', id: "arm71", cliff: 7 },
	{ name: 'ARM 10/1', id: "arm101", cliff: 10 },
	{ name: 'Fixed', id: "fixed", cliff: 0 },
]

export const termoptions = [
	{ name: '30 year', id: "year30", years: 30 },
	{ name: '25 year', id: "year25", years: 25 },
	{ name: '20 year', id: "year20", years: 20 },
	{ name: '15 year', id: "year15", years: 15 },
	{ name: '10 year', id: "year10", years: 10 },
]

export const CurrentStage = {
    Application: 1,
    Processing: 2,
    Closing: 3,
    Disposed: 4,
}

export const CurrentStatus = {
    // Application (100-199)
    ApplicationStarted: 100,
    ApplicationFinished: 101,
    PrequalSent: 102,

    // Processing (200-299)
    InContract: 200,
    OpenEscrow: 201,
    ConditionsRequested: 202,
    ConditionsReviewed: 203,
    OrderAppraisal: 204,
    TitleSearch: 205,
    PreApproved: 206,

    // Closing (300-399)
    SubmittedToUnderwriting: 300,
    ConditionalApproval: 301,
    ClearToClose: 302,
    DocsOut: 303,
    DocsSigned: 304,
    LoanFunded: 305,

    // Disposed (400-499)
    // ApplicationAbandoned: 400,
    // ApplicationRejected: 401,
    // PreApprovalDenied: 402,
    // FileClosedForIncompleteness: 403,
    // ApplicationWithdrawn: 404,
    // ApplicationDenied: 405,
	Withdrawn:400,
	Denied:401,
	PreApprovalRequestedDenied:402,
	ClosedForIncompleteness:403,
	CounterOfferDenied:405, //add
    ApprovedButNotAccepted: 406,
    Other: 499
};

// Reverse mapping
export const CurrentStatusNames = Object.fromEntries(
    Object.entries(CurrentStatus).map(([key, value]) => [value, key])
);

// Utility functions
export const CurrentStatusUtils = {
    getStage(statusCode) {
        if (statusCode >= 100 && statusCode < 200) return 'Application';
        if (statusCode >= 200 && statusCode < 300) return 'Processing';
        if (statusCode >= 300 && statusCode < 400) return 'Closing';
        if (statusCode >= 400 && statusCode < 500) return 'Disposed';
        return 'Unknown';
    },

    getStatusName(status) {
		if (!status) return '';
		const splitted = status.split(/(?=[A-Z])/);
		const firstWord = splitted[0];
		const restOfWords = splitted.slice(1).map(word => word.toLowerCase()).join(' ');
        return `${firstWord} ${restOfWords}`;
    },

    isFinalStatus(statusCode) {
        return statusCode >= 400;
    },

    isActiveStatus(statusCode) {
        return statusCode >= 200 && statusCode < 400;
    },

    getStatusesByStage(stage, loanPurpose) {
        const stageRanges = {
            'Application': [100, 199],
            'Processing': [200, 299],
            'Closing': [300, 399],
            'Disposed': [400, 499]
        };
		const nonEmptyLoanPurpose = loanPurpose || 'purchase';
        const range = stageRanges[stage];
        if (!range) return [];

        const filteredStatuses = Object.entries(CurrentStatus)
            .filter(([_, value]) => value >= range[0] && value <= range[1])
			.filter(([statusName, _]) => {
				if (
					nonEmptyLoanPurpose.toLocaleLowerCase() === 'refinance' ||
					nonEmptyLoanPurpose.toLocaleLowerCase() === 'cashoutrefinance'
				) {
					return statusName !== 'InContract';
				}
				return true;
			})
            .map(([key, value]) => ({
                code: value,
                name: key
            }));

        return filteredStatuses;
    },

	getStatusTextColor(status) {
		const statusID = CurrentStatus[status];
		if (!statusID) return 'white';
		if (statusID >= 100 && statusID < 200) return '#13358D';
		if (statusID >= 200 && statusID < 300) return '#13358D';
		if (statusID >= 300 && statusID < 400) return '#2E605A';
		if (statusID >= 400 && statusID < 500) return '#6E6E70';
		return 'white';
	},

	getStatusBackgroundColor(status) {
		const statusID = CurrentStatus[status];
		if (!statusID) return 'white';
		if (statusID >= 100 && statusID < 200) return 'white';
		if (statusID >= 200 && statusID < 300) return '#D8EAFF';
		if (statusID >= 300 && statusID < 400) return '#E1F2E2';
		if (statusID >= 400 && statusID < 500) return '#DBDCDE';
		return 'white';
	},
	getStatusBorderColor(status) {
		const statusID = CurrentStatus[status];
		if (!statusID) return 'white';
		if (statusID >= 100 && statusID < 200) return '#13358D';
		if (statusID >= 200 && statusID < 300) return '#D8EAFF';
		if (statusID >= 300 && statusID < 400) return '#E1F2E2';
		if (statusID >= 400 && statusID < 500) return '#DBDCDE';
		return 'white';
	}
}

// Example usage:
/*
console.log(CurrentStatus.ApplicationStarted); // 100
console.log(CurrentStatusUtils.getStatusName(CurrentStatus.ApplicationStarted)); // "Application Started"
console.log(CurrentStatusUtils.getStage(CurrentStatus.DocsSigned)); // "Closing"
console.log(CurrentStatusUtils.getStatusesByPhase('Processing')); // Returns all processing phase statuses
*/


export const loanstatuses = [
    'interviewstarted',
    'productselected',
    'interviewfinished',
    'documentationrequested',
    'loansubmitted',
    'conditionallyapproved',
    'loanafinalapproved',
    'submittedtoescrow',
    'finaldocssigned',
    'fundsreleased',
    'applicationwithdrawn',
    'applicationabandoned',
    'aplicationrejected',
    'borrowerwithdrew',
    'loancanceled',
    'loandenied',
    'readyforsubmit',
    'pendingrateselection',
    'applicationdenied',
    'indocs',
]

export const endoflinestatuses = [
    'fundsreleased',
    'applicationwithdrawn',
    'applicationabandoned',
    'aplicationrejected',
    'borrowerwithdrew',
    'loancanceled',
    'loandenied',
]

export function getNumericalStatus(status) {
	let current = 0
	switch (status) {
		case 'interviewstarted':
		default:
			current = 0
			break
		case 'productselected':
			current = 1
			break
		case 'interviewfinished':
			current = 2
			break
		case 'loansubmitted':
			current = 3
			break
		case 'documentationrequested':
			current = 4
			break
		case 'conditionallyapproved':
			current = 5
			break
		case 'loanafinalapproved':
			current = 6
			break
		case 'submittedtoescrow':
			current = 7
			break
		case 'finaldocssigned':
			current = 8
			break
		case 'fundsreleased':
			current = 9
			break;
		case 'applicationwithdrawn':
			current = 10
			break
		case 'applicationabandoned':
			current = 11
			break
		case 'aplicationrejected':
			current = 12
			break
		case "borrowerwithdrew":
			current = 13
			break
		case "loancanceled":
			current = 14
			break
		case "loandenied":
			current = 15
			break
	}
	return current
}

export const loanStatus = [
	'Interview Started',
	'Product Selected',
	'Interview Finished',
	'Pending Tasks',
	'Loan Submitted',
	'Conditionally Approved',
	'Loan Final Approved',
	'Submitted To Escrow',
	'Final Docs Signed',
	'Loan Funded',
	'Application Withdrawn',
	'Application Abandoned',
	'Application Rejected',
	"Borrower Withdrew",
	"Loan Cancelled",
	"Loan Denied",
	'Initialized By LO',
	'Undefined',
]

export const loanStatusMap = {
	'interviewstarted': 'Interview Started',
	'productselected': 'Product Selected',
	'interviewfinished': 'Interview Finished',
	'documentationrequested': 'Pending Tasks',
	'loansubmitted': 'Loan Submitted',
	'conditionallyapproved': 'Conditionally Approved',
	'loanafinalapproved': 'Loan Final Approved',
	'submittedtoescrow': 'Submitted To Escrow',
	'finaldocssigned': 'Final Docs Signed',
	'fundsreleased': 'Loan Funded',
	'applicationwithdrawn': 'Application Withdrawn',
	'applicationabandoned': 'Application Abandoned',
	'aplicationrejected': 'Application Rejected',
	"borrowerwithdrew": "Borrower Withdrew",
	"loancanceled": "Loan Cancelled",
	"loandenied": "Loan Denied",
	"loinitialized": "Initialized By LO",
	"indocs": "In Docs",
	"readyforsubmit": "Ready For Submission",
	"applicationdenied": "Application Denied",
	"pendingrateselection": "Pending Rate Selection"
};

export function splitStatusByWords(status) {
	return loanStatusMap[status] || 'Undefined';
}

export function mapStatusTagColor(status) {
	switch (status) {
		case 'interviewstarted':
			return 'blue'
		case 'productselected':
			return 'geekblue'
		case 'interviewfinished':
			return 'cyan'
		case 'documentationrequested':
			return 'warning'
		case 'loansubmitted':
			return 'magenta'
		case 'conditionallyapproved':
			return 'lime'
		case 'loanafinalapproved':
			return 'green'
		case 'submittedtoescrow':
			return 'purple'
		case 'finaldocssigned':
			return 'gold'
		case 'fundsreleased':
			return 'processing'
		case 'applicationwithdrawn':
			return 'error'
		case 'applicationabandoned':
			return 'warning'
		case 'aplicationrejected':
			return 'red'
		case "borrowerwithdrew":
			return "volcano"
		case "loancanceled":
			return "orange"
		case "loandenied":
			return "error"
		case "loinitialized":
			return "cyan"
		default:
			return ''
	}
}

export function safeParseInt(a) {
	if (a === "")
		return 0

	const b = parseInt(a)
	if (isNaN(b))
		return 0

	return b
}

export function safeParseFloat(a) {
	if (a === "")
		return 0

	const b = parseFloat(a)
	console.log("safeParseFloat", a, b)

	if (isNaN(b))
		return 0

	return b
}

export function MonthlyPayment(i, P, n) {
	const out = P * i * Math.pow(1 + i, n) / (Math.pow(1 + i, n) - 1)
	return out
}

function getRateFromExistingLien(P, n, M, ilow, ihigh, i = 0) {
	const mlow = MonthlyPayment(ilow, P, n)
	const imid = 0.5 * (ilow + ihigh)
	const mmiddle = MonthlyPayment(imid, P, n)

	if (M >= mlow && M <= mmiddle) {
		ihigh = imid
	} else {
		ilow = imid
	}
	if (ihigh - ilow < 0.000001) {
		return 0.5 * (ihigh + ilow)
	}
	return getRateFromExistingLien(P, n, M, ilow, ihigh, i + 1)
}

export function getYearlyRate(P, n, M) {
	const out = getRateFromExistingLien(P, n + 1, M, 0.01 / 12, 0.2 / 12)

	let yearly = 12 * out
	yearly = Math.round(yearly * 100000) / 1000
	return yearly
}

export function getMonthlyValue(value, period) {
	switch (period) {
		case "monthly":
		default:
			return parseFloat(value)
		case "yearly":
			return parseFloat(value) / 12
		case "daily":
			return parseFloat(value) * 261 / 12;
	}
}

export function redirectValidation() {
	return returnURLs.landingurl + returnURLs.loginpath
}

export let returnURLs = { publicSite: "/" }

export function redirectPublicWebsite() {
	const paths = sessionStorage.getItem("paths")
	if (paths != null && paths !== "") {
		const urls = JSON.parse(paths)
		return urls.website
	}


	if (undefined === returnURLs.landingurl) {
		const js = localStorage.getItem("redirects")
		if (js != null && js !== "")
			returnURLs = JSON.parse(js)
	}
	// now let's see where we are

	return returnURLs.landingurl
}

export function getCompanyName() {
	const js = localStorage.getItem("redirects")
	if (js != null && js !== "") {
		returnURLs = JSON.parse(js)
		return returnURLs["name"]
	}
	return ""
}

export function updateReturnUrls(s) {
	Object.keys(s).forEach(key => {
		returnURLs[key] = s[key]
	})
	localStorage.setItem("redirects", JSON.stringify(returnURLs))
}

export let customization = null

export function setCustomization(c) {
	customization = c
	localStorage.setItem("customization", JSON.stringify(c))
}

export function checkCustomization() {
	if (customization == null) {
		const c = localStorage.getItem("customization")
		if (c !== "" && c != null)
			customization = JSON.parse(c)
	}
}

export function getReturnURLs() {
	const token = getUserToken()
	fetch('/api/getreturns', {
		method: 'GET',
		headers: {
			Authorization: "Bearer " + token, // may be expired
			Cache: "no-cache"
		}
	}).then(
		response => {
			if (response.status !== 200) {
				console.log('Looks like there was a problem. Status Code: ' +
					response.status);
				return;
			}
			// Examine the text in the response
			response.json().then(js => {
				returnURLs = js
				localStorage.setItem("redirects", JSON.stringify(js))
			});
		}
	)
		.catch(function (err) {
			console.log('Fetch Error :', err);
		});
	return
}

export function touch() {
	window.document.dispatchEvent(new Event('checkwalkback'), "");
}

export const upfrontMI = "Upfront Mortgage Insurance Premium"

export const counties = JSON.parse('{"ALAMEDA COUNTY":["$822,375","$1,053,000","$1,272,750","$1,581,750"],"ALPINE COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"AMADOR COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"BUTTE COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"CALAVERAS COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"COLUSA COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"CONTRA COSTA COUNTY":["$822,375","$1,053,000","$1,272,750","$1,581,750"],"DEL NORTE COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"EL DORADO COUNTY":["$598,000","$765,550","$925,350","$1,150,000"],"FRESNO COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"GLENN COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"HUMBOLDT COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"IMPERIAL COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"INYO COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"KERN COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"KINGS COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"LAKE COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"LASSEN COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"LOS ANGELES COUNTY":["$822,375","$1,053,000","$1,272,750","$1,581,750"],"MADERA COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"MARIN COUNTY":["$822,375","$1,053,000","$1,272,750","$1,581,750"],"MARIPOSA COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"MENDOCINO COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"MERCED COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"MODOC COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"MONO COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"MONTEREY COUNTY":["$739,450","$946,650","$1,144,250","$1,422,050"],"NAPA COUNTY":["$816,500","$1,045,250","$1,263,500","$1,570,200"],"NEVADA COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"ORANGE COUNTY":["$822,375","$1,053,000","$1,272,750","$1,581,750"],"PLACER COUNTY":["$598,000","$765,550","$925,350","$1,150,000"],"PLUMAS COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"RIVERSIDE COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"SACRAMENTO COUNTY":["$598,000","$765,550","$925,350","$1,150,000"],"SAN BENITO COUNTY":["$822,375","$1,053,000","$1,272,750","$1,581,750"],"SAN BERNARDINO COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"SAN DIEGO COUNTY":["$753,250","$964,300","$1,165,600","$1,448,600"],"SAN FRANCISCO COUNTY":["$822,375","$1,053,000","$1,272,750","$1,581,750"],"SAN JOAQUIN COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"SAN LUIS OBISPO COUNTY":["$701,500","$898,050","$1,085,550","$1,349,050"],"SAN MATEO COUNTY":["$822,375","$1,053,000","$1,272,750","$1,581,750"],"SANTA BARBARA COUNTY":["$660,100","$845,050","$1,021,450","$1,269,450"],"SANTA CLARA COUNTY":["$822,375","$1,053,000","$1,272,750","$1,581,750"],"SANTA CRUZ COUNTY":["$822,375","$1,053,000","$1,272,750","$1,581,750"],"SHASTA COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"SIERRA COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"SISKIYOU COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"SOLANO COUNTY":["$550,850","$705,200","$852,400","$1,059,350"],"SONOMA COUNTY":["$707,250","$905,400","$1,094,450","$1,360,100"],"STANISLAUS COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"SUTTER COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"TEHAMA COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"TRINITY COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"TULARE COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"TUOLUMNE COUNTY":["$548,250","$702,000","$848,500","$1,054,500"],"VENTURA COUNTY":["$739,450","$946,650","$1,144,250","$1,422,050"],"YOLO COUNTY":["$598,000","$765,550","$925,350","$1,150,000"],"YUBA COUNTY":["$548,250","$702,000","$848,500","$1,054,500"]}')
export const texasCounties = ["ANDERSON COUNTY", "ANDREWS COUNTY", "ANGELINA COUNTY", "ARANSAS COUNTY", "ARCHER COUNTY", "ARMSTRONG COUNTY", "ATASCOSA COUNTY", "AUSTIN COUNTY", "BAILEY COUNTY", "BANDERA COUNTY", "BASTROP COUNTY", "BAYLOR COUNTY", "BEE COUNTY", "BELL COUNTY", "BEXAR COUNTY", "BLANCO COUNTY", "BORDEN COUNTY", "BOSQUE COUNTY", "BOWIE COUNTY", "BRAZORIA COUNTY", "BRAZOS COUNTY", "BREWSTER COUNTY", "BRISCOE COUNTY", "BROOKS COUNTY", "BROWN COUNTY", "BURLESON COUNTY", "BURNET COUNTY", "CALDWELL COUNTY", "CALHOUN COUNTY", "CALLAHAN COUNTY", "CAMERON COUNTY", "CAMP COUNTY", "CARSON COUNTY", "CASS COUNTY", "CASTRO COUNTY", "CHAMBERS COUNTY", "CHEROKEE COUNTY", "CHILDRESS COUNTY", "CLAY COUNTY", "COCHRAN COUNTY", "COKE COUNTY", "COLEMAN COUNTY", "COLLIN COUNTY", "COLLINGSWORTH COUNTY", "COLORADO COUNTY", "COMAL COUNTY", "COMANCHE COUNTY", "CONCHO COUNTY", "COOKE COUNTY", "CORYELL COUNTY", "COTTLE COUNTY", "CRANE COUNTY", "CROCKETT COUNTY", "CROSBY COUNTY", "CULBERSON COUNTY", "DALLAM COUNTY", "DALLAS COUNTY", "DAWSON COUNTY", "DEAF SMITH COUNTY", "DELTA COUNTY", "DENTON COUNTY", "DEWITT COUNTY", "DICKENS COUNTY", "DIMMIT COUNTY", "DONLEY COUNTY", "DUVAL COUNTY", "EASTLAND COUNTY", "ECTOR COUNTY", "EDWARDS COUNTY", "ELLIS COUNTY", "EL PASO COUNTY", "ERATH COUNTY", "FALLS COUNTY", "FANNIN COUNTY", "FAYETTE COUNTY", "FISHER COUNTY", "FLOYD COUNTY", "FOARD COUNTY", "FORT BEND COUNTY", "FRANKLIN COUNTY", "FREESTONE COUNTY", "FRIO COUNTY", "GAINES COUNTY", "GALVESTON COUNTY", "GARZA COUNTY", "GILLESPIE COUNTY", "GLASSCOCK COUNTY", "GOLIAD COUNTY", "GONZALES COUNTY", "GRAY COUNTY", "GRAYSON COUNTY", "GREGG COUNTY", "GRIMES COUNTY", "GUADALUPE COUNTY", "HALE COUNTY", "HALL COUNTY", "HAMILTON COUNTY", "HANSFORD COUNTY", "HARDEMAN COUNTY", "HARDIN COUNTY", "HARRIS COUNTY", "HARRISON COUNTY", "HARTLEY COUNTY", "HASKELL COUNTY", "HAYS COUNTY", "HEMPHILL COUNTY", "HENDERSON COUNTY", "HIDALGO COUNTY", "HILL COUNTY", "HOCKLEY COUNTY", "HOOD COUNTY", "HOPKINS COUNTY", "HOUSTON COUNTY", "HOWARD COUNTY", "HUDSPETH COUNTY", "HUNT COUNTY", "HUTCHINSON COUNTY", "IRION COUNTY", "JACK COUNTY", "JACKSON COUNTY", "JASPER COUNTY", "JEFF DAVIS COUNTY", "JEFFERSON COUNTY", "JIM HOGG COUNTY", "JIM WELLS COUNTY", "JOHNSON COUNTY", "JONES COUNTY", "KARNES COUNTY", "KAUFMAN COUNTY", "KENDALL COUNTY", "KENEDY COUNTY", "KENT COUNTY", "KERR COUNTY", "KIMBLE COUNTY", "KING COUNTY", "KINNEY COUNTY", "KLEBERG COUNTY", "KNOX COUNTY", "LAMAR COUNTY", "LAMB COUNTY", "LAMPASAS COUNTY", "LA SALLE COUNTY", "LAVACA COUNTY", "LEE COUNTY", "LEON COUNTY", "LIBERTY COUNTY", "LIMESTONE COUNTY", "LIPSCOMB COUNTY", "LIVE OAK COUNTY", "LLANO COUNTY", "LOVING COUNTY", "LUBBOCK COUNTY", "LYNN COUNTY", "MCCULLOCH COUNTY", "MCLENNAN COUNTY", "MCMULLEN COUNTY", "MADISON COUNTY", "MARION COUNTY", "MARTIN COUNTY", "MASON COUNTY", "MATAGORDA COUNTY", "MAVERICK COUNTY", "MEDINA COUNTY", "MENARD COUNTY", "MIDLAND COUNTY", "MILAM COUNTY", "MILLS COUNTY", "MITCHELL COUNTY", "MONTAGUE COUNTY", "MONTGOMERY COUNTY", "MOORE COUNTY", "MORRIS COUNTY", "MOTLEY COUNTY", "NACOGDOCHES COUNTY", "NAVARRO COUNTY", "NEWTON COUNTY", "NOLAN COUNTY", "NUECES COUNTY", "OCHILTREE COUNTY", "OLDHAM COUNTY", "ORANGE COUNTY", "PALO PINTO COUNTY", "PANOLA COUNTY", "PARKER COUNTY", "PARMER COUNTY", "PECOS COUNTY", "POLK COUNTY", "POTTER COUNTY", "PRESIDIO COUNTY", "RAINS COUNTY", "RANDALL COUNTY", "REAGAN COUNTY", "REAL COUNTY", "RED RIVER COUNTY", "REEVES COUNTY", "REFUGIO COUNTY", "ROBERTS COUNTY", "ROBERTSON COUNTY", "ROCKWALL COUNTY", "RUNNELS COUNTY", "RUSK COUNTY", "SABINE COUNTY", "SAN AUGUSTINE COUNTY", "SAN JACINTO COUNTY", "SAN PATRICIO COUNTY", "SAN SABA COUNTY", "SCHLEICHER COUNTY", "SCURRY COUNTY", "SHACKELFORD COUNTY", "SHELBY COUNTY", "SHERMAN COUNTY", "SMITH COUNTY", "SOMERVELL COUNTY", "STARR COUNTY", "STEPHENS COUNTY", "STERLING COUNTY", "STONEWALL COUNTY", "SUTTON COUNTY", "SWISHER COUNTY", "TARRANT COUNTY", "TAYLOR COUNTY", "TERRELL COUNTY", "TERRY COUNTY", "THROCKMORTON COUNTY", "TITUS COUNTY", "TOM GREEN COUNTY", "TRAVIS COUNTY", "TRINITY COUNTY", "TYLER COUNTY", "UPSHUR COUNTY", "UPTON COUNTY", "UVALDE COUNTY", "VAL VERDE COUNTY", "VAN ZANDT COUNTY", "VICTORIA COUNTY", "WALKER COUNTY", "WALLER COUNTY", "WARD COUNTY", "WASHINGTON COUNTY", "WEBB COUNTY", "WHARTON COUNTY", "WHEELER COUNTY", "WICHITA COUNTY", "WILBARGER COUNTY", "WILLACY COUNTY", "WILLIAMSON COUNTY", "WILSON COUNTY", "WINKLER COUNTY", "WISE COUNTY", "WOOD COUNTY", "YOAKUM COUNTY", "YOUNG COUNTY", "ZAPATA COUNTY", "ZAVALA COUNTY"]

export function sortFullNameByLastAndFirst(a, b, order) {
	let aFirst, aMiddle, aLast, bFirst, bMiddle, bLast
	const [A, B] = [a, b].map(el => el.toUpperCase().split(/ +/))
	if (A.length === 2) {
		[aFirst, aLast] = A
	} else if (A.length === 3) {
		/* eslint-disable-next-line no-unused-vars */
		[aFirst, aMiddle, aLast] = A
	}
	if (B.length === 2) {
		[bFirst, bLast] = B
	} else if (B.length === 3) {
		/* eslint-disable-next-line no-unused-vars */
		[bFirst, bMiddle, bLast] = B
	}

	const isAsc = order === 'asc'

	if (bLast < aLast) {
		return isAsc ? -1 : 1
	} else if (bLast > aLast) {
		return isAsc ? 1 : -1
	} else if (bLast === aLast) {
		if (bFirst < aFirst) {
			return isAsc ? -1 : 1
		} else if (bFirst > aFirst) {
			return isAsc ? 1 : -1
		}
	}
}

export function getOccupancy(occupancy) {
	switch (occupancy) {
		case "principal":
			return "PRIMARY"
		case "secondhome":
			return "SECOND_HOME"
		case "investment":
			return "INVESTMENT"
		default:
			alert("wrong occupancy")
			return "PRIMARY"
	}
}

export function getPropertyType(propertytype) {
	const remap = {
		condominiumdetached: "CONDOMINIUM_DETACHED",
		condominium: "CONDOMINIUM_ATTACHED",
		pudattached: "PUD_ATTACHED",
		puddetached: "PUD_DETACHED",
		singlefamilyattached: "SINGLE_FAMILY_ATTACHED",
		singlefamilydetached: "SINGLE_FAMILY_DETACHED",
		twotofourfamily: "TWO_TO_FOUR_FAMILY",
		manufacturedhome: "MANUFACTURED_HOME"
	}
	const out = remap[propertytype]
	return out
}

export function getPropertyTypeName(propertytype) {
	const remap = {
		condominiumdetached: "Condo",
		condominium: "Condo",
		pudattached: "PUD",
		puddetached: "PUD",
		singlefamilyattached: "Single family",
		singlefamilydetached: "Single family",
		twotofourfamily: "Multifamily (1-4 unit)",
		commercial: "Multifamily (5+ unit)",
		manufacturedhome: "Manufactured home",
		mobilehome: "Mobile home",
	}
	const out = remap[propertytype]
	return out
}

export function interviewStepToSubstatus(step) {
	switch (step) {
		case 0:
			return `Start/Tell us about how you are applying for a loan`
		case 1:
			return `Start/Your invited coborrowers`
		case 2:
			return `Start/Please tell us about yourself and your primary residence`
		case 3:
			return `Start/Please enter co-applicant's information`
		case 4:
			return `Property/Let's enter the subject property information`
		case 5:
			return `Property`
		case 6:
			return `Property`
		case 7:
			return `Property`
		case 8:
			return `Income/Tell us about applicant's income`
		case 9:
			return `Income/Tell us more about applicant's income`
		case 10:
			return `Income/Tell us about co applicant's income`
		case 11:
			return `Income/Tell us more about co applicant's income`
		case 12:
			return `Assets/Tell us about applicant's finances`
		case 13:
			return `Assets/More about applicant's finances`
		case 14:
			return `Assets/Tell us about applicants' finances`
		case 15:
			return `Assets/More about co applicant's finances`
		case 16:
			return `Assets`
		case 17:
			return `Liabilities/You're about to review your debts and liabilities`
		case 18:
			return `Liabilities/Please sign the authorization form`
		case 19:
			return `Liabilities/applicant's Liabilities From Credit Report`
		case 20:
			return `Liabilities/applicant's Liabilities From Credit Report`
		case 21:
			return `Liabilities/More on applicant's Liabilities`
		case 22:
			return `Liabilities/More on co applicant's Liabilities`
		case 23:
			return `Liabilities/applicants' current housing expenses for the primary residence`
		case 24:
			return `Liabilities/applicants' current housing expenses for the primary residence`
		case 25:
			return `(not done yet) Before we show you the best products out of thousands...`
		case 26:
			return `Prequal`
		case 27:
			return `Loan Choice/Select the mortgage loan`
		case 28:
			return `Transaction`
		case 29:
			return `Declarations/Declarations`
		case 30:
			return `Declarations/Information for government monitoring purposes`
		case 31:
			return `Finished`
		default:
			return `The initial interview is complete!`
	}
}

export function Purpose2Calculator(p) {
	switch (p) {
		case "refinance": return "RateTermRefi"
		case "cashoutrefinance": return "CashOutRefi"
		case "purchase": default: return "Purchase"
	}
}

export function sortDates(date1, date2, isAsc) {
	let answer = date1.getTime() - date2.getTime()
	return isAsc ? answer : -answer
}

export function dateToStringMMDDYYYY(date) {
	const month = String(date.getMonth() + 1).padStart(2, "0");
	if (month === "NaN") {
		return "-"
	}
	const day = String(date.getDate()).padStart(2, "0");
	const year = String(date.getFullYear()).slice(-2);

	const formattedDate = `${month}/${day}/${year}`;
	return formattedDate
}

export function formatAddress(a) {
	return a.presentaddressstreet + ", " +
		((a.presentaddressunit != null && a.presentaddressunit !== "") ?
			("Apt. " + a.presentaddressunit + ", ")
			: "") +
		a.presentaddresscity + ", " +
		a.presentaddressstate + " " +
		a.presentaddresszip
}

/** Join address parts; skip blanks and trim stray commas so we never render ",,". */
export function joinAddressParts() {
	const flattened = []
	for (let i = 0; i < arguments.length; i++) {
		const part = arguments[i]
		if (Array.isArray(part)) {
			for (let j = 0; j < part.length; j++) {
				flattened.push(part[j])
			}
		} else {
			flattened.push(part)
		}
	}
	return flattened
		.map((part) => String(part == null ? "" : part).trim().replace(/^,+|,+$/g, "").trim())
		.filter(Boolean)
		.join(", ")
}

/** Normalize a stored address string that may contain empty segments / double commas. */
export function compactAddressDisplay(address) {
	if (address == null || address === "") {
		return ""
	}
	return joinAddressParts(String(address).split(","))
}

export function isHeloc(loan) {
	return loan.creditloantype.toLowerCase().indexOf("homeequity") >= 0
}

export function isHomeloan(loan) {
	if (!loan.creditloantype) return false
	return loan.creditloantype.toLowerCase().indexOf("mortgage") >= 0 ||
		loan.creditloantype.toLowerCase().indexOf("homeequity") >= 0 ||
		loan.creditloantype.toLowerCase().indexOf("realestate") >= 0
}

// Zeitro logo
export let logo = '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';
export let companyName = 'Zeitro'


export function insertCssColors(customerID) {
	const insertStyleSheet = (colors) => {
		const style = document.createElement('style')
		style.type = 'text/css'
		style.innerHTML = colors

		document.getElementsByTagName('head')[0].appendChild(style);
	}

	const defaultZeitroColors = `
  :root{
  --primary-color: #242c42;
  --primary-color-text: #eee;
  --primary-color-2: #303b57;
  --primary-color-2-text: #eee;
  --primary-color-3: #263272;
  --primary-color-3-text: #eee;
  --primary-pale: #7189c9;
  --primary-pale-text: #222;
  --secondary-color: #050c45;
  }
  `

	let appliedColors = defaultZeitroColors;

	fetch('/data/companycustomization', {
		headers: {
			'X-CustomerId': customerID || 'zeitro',
		}
	})
		.then(async response => {
			if (!response.ok) {
				return;
			}
			await response.json().then(json => {
				let customizationObj = JSON.parse(json.Customization)
				if (Object.keys(customizationObj).includes('primaryColor')) {
					let { primaryColor, primaryColorText, primaryColor2, primaryColor2Text, primaryColor3,
						primaryColor3Text, paleColor, paleColorText, secondaryColor, icon } = customizationObj;
					appliedColors = `
          :root{
            --primary-color: ${primaryColor};
            --primary-color-text: ${primaryColorText};
            --primary-color-2: ${primaryColor2};
            --primary-color-2-text: ${primaryColor2Text};
            --primary-color-3: ${primaryColor3};
            --primary-color-3-text: ${primaryColor3Text};
            --primary-pale: ${paleColor};
            --primary-pale-text: ${paleColorText};
            --secondary-color: ${secondaryColor};
          }
          `
					if (icon) {
						logo = icon;
					}
					if (json.CompanyName) {
						companyName = json.CompanyName;
					}
				}
			})
		}).finally(() => {
			insertStyleSheet(appliedColors);
		});
};

export function purpose2phrase(purpose) {
	switch (purpose) {
		case "purchase":
		default:
			return "Home Purchase"
		case "refinance":
			return "Home Refinances"
		case "cashoutrefinance":
			return "Cash Out Refinane"
	}
}

/* operators
ConditionOperator:
  - equal
  - notequal
  - greater
  - less
  - greaterorequal
  - lessorequal
*/
export const operatorMap = {
	equal: "==",
	notequal: "!=",
	greater: ">",
	less: "<",
	greaterorequal: ">=",
	lessorequal: "<="
}

export const operatorInout = {
	equal: "inside",
	notequal: "outside",
}

export const operatorEnum = {
	equal: "is included in",
	notequal: "not included in",
}

export const operatorBool = {
	equal: "Is True",
	notequal: "Is False",
}

export const RuleSet = {
	LTVInterval: {
		name: "LTV",
		short: "LTV",
		typ: "minmax",
		values: "float",
		operators: ["equal", "notequal"],
	},
	FicoInterval: {
		name: "FICO",
		short: "FICO",
		typ: "minmax",
		values: "int",
		operators: ["equal", "notequal"]
	},
	DTIInterval: {
		name: "DTI",
		short: "DTI",
		typ: "minmax",
		values: "float",
		operators: ["equal", "notequal"]
	},
	LoanSizeInterval: {
		name: "Loan amount",
		short: "Loan amount",
		typ: "minmax",
		values: "dollar",
		operators: ["equal", "notequal"]
	},
	OccupancyType: {
		name: "Occupancy",
		short: "Occupancy",
		typ: "enum",
		values: {
			PRIMARY: "Primary Residence",
			SECOND_HOME: "Secondary Home",
			INVESTMENT: "Investment Property",
		},
		operators: ["equal", "notequal"]
	},
	PurposeType: {
		name: "Purpose",
		typ: "enum",
		values: {
			Purchase: "Purchase",
			RateTermRefi: "Rate and Term Refinance",
			CashOutRefi: "Cash Out Refinance",
			StreamlineRefi: "Streamline Refinance",
		},
		operators: ["equal", "notequal"]
	},
	PropertyType: {
		name: "Property Type",
		typ: "enum",
		values: {
			CONDOMINIUM_DETACHED: "Condo detached",
			CONDOMINIUM_ATTACHED: "Condo attached",
			PUD_ATTACHED: "PUD attached",
			PUD_DETACHED: "PUD detached",
			SINGLE_FAMILY_ATTACHED: "Single Family Attached",
			SINGLE_FAMILY_DETACHED: "Single Family Detached",
			TWO_TO_FOUR_FAMILY: "Two to Four Family Home",
			MANUFACTURED_HOME: "Manufactured Home",
			MODULAR_HOME: "Modular Home",
			MOBILE_HOME: "Mobile Home",
			CO_OP: "Cooperative",
		},
		operators: ["equal", "notequal"]
	},
	Units: {
		name: "Number of Units",
		typ: "value",
		values: "int",
		operators: ["equal", "notequal", "greater",
			"less", "greaterorequal", "lessorequal"]
	},
	ProductNameKeyword: {
		name: "Product Name Keyword",
		typ: "value",
		values: "string",
		operators: ["equal"]
	},
	State: {
		name: "State",
		typ: "enum",
		values: {
			"AL": "Alabama",
			"AK": "Alaska",
			"AS": "American Samoa",
			"AZ": "Arizona",
			"AR": "Arkansas",
			"CA": "California",
			"CO": "Colorado",
			"CT": "Connecticut",
			"DE": "Delaware",
			"DC": "District Of Columbia",
			"FM": "Federated States Of Micronesia",
			"FL": "Florida",
			"GA": "Georgia",
			"GU": "Guam",
			"HI": "Hawaii",
			"ID": "Idaho",
			"IL": "Illinois",
			"IN": "Indiana",
			"IA": "Iowa",
			"KS": "Kansas",
			"KY": "Kentucky",
			"LA": "Louisiana",
			"ME": "Maine",
			"MH": "Marshall Islands",
			"MD": "Maryland",
			"MA": "Massachusetts",
			"MI": "Michigan",
			"MN": "Minnesota",
			"MS": "Mississippi",
			"MO": "Missouri",
			"MT": "Montana",
			"NE": "Nebraska",
			"NV": "Nevada",
			"NH": "New Hampshire",
			"NJ": "New Jersey",
			"NM": "New Mexico",
			"NY": "New York",
			"NC": "North Carolina",
			"ND": "North Dakota",
			"MP": "Northern Mariana Islands",
			"OH": "Ohio",
			"OK": "Oklahoma",
			"OR": "Oregon",
			"PW": "Palau",
			"PA": "Pennsylvania",
			"PR": "Puerto Rico",
			"RI": "Rhode Island",
			"SC": "South Carolina",
			"SD": "South Dakota",
			"TN": "Tennessee",
			"TX": "Texas",
			"UT": "Utah",
			"VT": "Vermont",
			"VI": "Virgin Islands",
			"VA": "Virginia",
			"WA": "Washington",
			"WV": "West Virginia",
			"WI": "Wisconsin",
			"WY": "Wyoming",
		},
		operators: ["equal", "notequal"]

	},
	Citizenship: {
		name: "Citizenship",
		typ: "enum",
		values:
		{
			US_CITIZENS: "US Citizen",
			PERMANENT_RESIDENT_ALIEN: "Permanent Resident Alien",
			NON_PERMANENT_RESIDENT_ALIEN: "Non Permanent Resident Alien",
			//NON_PERMANENT_RESIDENT_ALIEN_ITIN: "",
			NON_RESIDENT_ALIEN: "Non Resident Alien"
		},
		operators: ["equal", "notequal"]

	},
	VisaType: {
		name: "Visa Type",
		typ: "enum",
		values:
		{
			A_1: "A1",
			A_2: "A2",
			A_3: "A3",
			B_1: "B3",
			B_2: "B2",
			B_3: "B3",
			C_1: "C1",
			C_2: "C2",
			C_3: "C3",
			C_4: "C4",
			C_1D: "C1D",
			CP: "CP",
			D_1: "D1",
			D_2: "D2",
			E_1: "E1",
			E_2: "E2",
			E_3: "E3",
			F_1: "F1",
			F_2: "F2",
			F_3: "F3",
			G_1: "G1",
			G_2: "G2",
			G_3: "G3",
			G_4: "G4",
			G_5: "G5",
			H_1A: "H1A",
			H_1B: "H1B",
			H_1B1: "H1B1",
			H_1C: "H1C",
			H_2: "H2",
			H_2A: "H2A",
			H_2B: "H2B",
			H_3: "H3",
			H_4: "H4",
			I: "I",
			OR_1: "OR1",
			J_1: "J1",
			J_2: "J2",
			K_1: "K1",
			K_2: "K2",
			K_3: "K3",
			K_4: "K4",
			L_1: "L1",
			L_2: "L2",
			M_1: "M1",
			M_2: "M2",
			M_3: "M3",
			N_8: "N8",
			N_9: "N9",
			NACARA: "NACARA",
			NATO_1_6: "NATO 1 6",
			NATO_7: "NATO 7",
			O_1: "O1",
			O_2: "O2",
			O_3: "O3",
			P_1: "P1",
			P_2: "P2",
			P_3: "P3",
			P_4: "P4",
			Q_1: "Q1",
			Q_2: "Q2",
			Q_3: "Q3",
			R_1: "R1",
			R_2: "R2",
			S_5: "S5",
			S_6: "S6",
			S_7: "S7",
			T_1: "T1",
			T_2: "T2",
			T_3: "T3",
			T_4: "T4",
			TD: "TD",
			TN_1: "TN1",
			TN_2: "TN2",
			U_1: "U1",
			U_2: "U2",
			U_3: "U3",
			U_4: "U4",
			V_1: "V1",
			V_2: "V2",
			V_3: "V3",
		},
		operators: ["equal", "notequal"]
	},
	MortgageType: {
		name: "Mortgage Type",
		typ: "enum",
		values:
		{
			CONFORMING: "Conforming",
			SUPER_CONFORMING: "Super Conforming",
			JUMBO: "Jumbo",
			FHA: "FHA",
			FHA_STREAMLINE: "FHA Streamline",
			FHA_STREAMLINE_JUMBO: "FHA Streamline Jumbo",
			FHA_HIGH_BALANCE: "FHA High Balance",
			FHA_JUMBO: "FHA Jumbo",
			FHA_HIGH_BALANCE_STREAMLINE: "FHA High Balance Streamline",
			FHA_203K: "FHA 203K",
			FHA_203K_HIGH_BALANCE: "FHA 203K High Balance",
			VA: "VA",
			VA_HIGH_BALANCE: "VA High Balance",
			VA_JUMBO: "VA Jumbo",
			VA_IRRRL: "VA IRRRL",
			VA_HIGH_BALANCE_IRRRL: "VA High Balance IRRRL",
			VA_IRRRL_JUMBO: "VA IRRRL Jumbo",
			VA_RENOVATION: "VA Renovation",
			USDA: "USDA",
			USDA_STREAMLINE: "USDA Streamline",
			NON_QM: "Non QM",
			HOME_READY: "Home Ready",
			HOME_POSSIBLE: "Home Possible",
			HOME_READY_HIGH_BALANCE: "Home Ready High Balance",
			HOME_POSSIBLE_HIGH_BALANCE: "Home Possible High Balance",
			HOME_ONE: "Home One",
			HOME_STYLE: "Home Style",
			HOME_STYLE_HIGH_BALANCE: "Home Style High Balance",
			REFI_NOW: "Refi Now",
			COMBINATION: "Combination",
			CHOICERenovation: "Choice Renovation",
			CHOICERenovation_SUPER_CONFORMING: "Choice Renovation Super Conforming",
			DOCTOR: "Doctor",
			DOCTOR_HIGH_BALANCE: "Doctor High Balance",
			ENHANCED_RELIEF_REFINANCE: "Enhanced Relief Refinance",
			ENHANCED_RELIEF_REFINANCE_HIGH_BALANCE: "Enhanced Relief Refinance High Balance",
			HIGH_LTV_REFINANCE: "High LTV Refinance",
			HIGH_LTV_REFINANCE_HIGH_BALANCE: "High LTV Refinance High Balance",
		},
		operators: ["equal", "notequal"]
	},
	NumberOfOwnedProperties: {
		name: "Number Of Owned Properties",
		typ: "value",
		values: "int",
		operators: ["equal", "notequal", "greater",
			"less", "greaterorequal", "lessorequal"]
	},
	IsSelfEmployed: {
		name: "Is Self Employed",
		typ: "bool",
		values: "bool",
		operators: ["equal", "notequal"]
	},
	EscrowWaiver: {
		name: "Escrow Waiver",
		typ: "bool",
		values: "bool",
		operators: ["equal", "notequal"]
	},
	AppraisalWaiver: {
		name: "Appraisal Waiver",
		typ: "bool",
		values: "bool",
		operators: ["equal", "notequal"]
	},
	CurrentJobInMonths: {
		name: "Current Job In Months",
		typ: "value",
		values: "int",
		operators: ["greater",
			"less", "greaterorequal", "lessorequal"]
	},
	JobGapInMonths: {
		name: "Job Gap In Months",
		typ: "value",
		values: "int",
		operators: ["greater",
			"less", "greaterorequal", "lessorequal"]
	},
	RSUAsIncome: {
		name: "RSU As Income",
		typ: "value",
		values: "dollar",
		operators: ["greater",
			"less", "greaterorequal", "lessorequal"]
	},
	UseGiftFund: {
		name: "Use Gift Fund",
		typ: "bool",
		values: "bool",
		operators: ["equal", "notequal"]
	},
	FamilyRelatedOrSmallBusiness: {
		name: "Family Related Or Small Business",
		typ: "bool",
		values: "bool",
		operators: ["equal", "notequal"]
	}
}

export const LenderRelationshhip = {
	Broker: {
		name: "Broker",
	},
	NondedicatedCorrespondentLender: {
		name: "Non-delegated Correspondent Lender",

	},
	DedicatedCorrespondentLender: {
		name: "Delegated Correspondent Lender",
	},
	DirecttLender: {
		name: "Direct Lender",
	}
}

export function getPrimaryAddress(who, application) {
	let _who = who
	if (application.cohabiting && who === "coborrower")
		_who = "borrower"

	const st = application[_who].presentaddressstreet
	const city = application[_who].presentaddresscity
	const state = application[_who].presentaddressstate
	const zip = application[_who].presentaddresszip
	const apt = application[_who].presentaddressunit

	let address = st
	if (apt != null && apt !== "")
		address += ', Apt ' + apt

	address += ', ' + city
	address += ', ' + state
	address += ' ' + zip

	return address
}

export const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
]

export const callReportInitValues = {
	applicationdata: [
		{
			datapoint: "AC010",
			parameters: "Applications in Process at the Beignning of the Period",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			thirdpartyamount: 0,
			thirdpartycount: 0,
			thirdpartyaverage: 0,
		},
		{
			datapoint: "AC020",
			parameters: "Applications Received",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			thirdpartyamount: 0,
			thirdpartycount: 0,
			thirdpartyaverage: 0,
		},
		{
			datapoint: "AC030",
			parameters: "Applications Approved but not Accepted",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			thirdpartyamount: 0,
			thirdpartycount: 0,
			thirdpartyaverage: 0,
		},
		{
			datapoint: "AC040",
			parameters: "Applications Denied",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			thirdpartyamount: 0,
			thirdpartycount: 0,
			thirdpartyaverage: 0,
		},
		{
			datapoint: "AC050",
			parameters: "Applications Withdrawn",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			thirdpartyamount: 0,
			thirdpartycount: 0,
			thirdpartyaverage: 0,
		},
		{
			datapoint: "AC060",
			parameters: "File Closed for Incompleteness",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			thirdpartyamount: 0,
			thirdpartycount: 0,
			thirdpartyaverage: 0,
		},
		{
			datapoint: "AC062",
			parameters: "Pre-Approval Requests Denied",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			thirdpartyamount: 0,
			thirdpartycount: 0,
			thirdpartyaverage: 0,
		},
		{
			datapoint: "AC064",
			parameters: "Pre-Approval Requests Approved but not Accepted",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			thirdpartyamount: 0,
			thirdpartycount: 0,
			thirdpartyaverage: 0,
		},
		{
			datapoint: "AC065",
			parameters: "Net Changes in Application Amount (decreases should be reflected as negative)",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			thirdpartyamount: 0,
			thirdpartycount: 0,
			thirdpartyaverage: 0,
		},
		{
			datapoint: "AC066",
			parameters: "Total Application Pipeline",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			thirdpartyamount: 0,
			thirdpartycount: 0,
			thirdpartyaverage: 0,
		},
		{
			datapoint: "AC070",
			parameters: "Loan Closed and Funded",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			thirdpartyamount: 0,
			thirdpartycount: 0,
			thirdpartyaverage: 0,
		},
		{
			datapoint: "AC080",
			parameters: "Applications in Process at the End of the Period",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			thirdpartyamount: 0,
			thirdpartycount: 0,
			thirdpartyaverage: 0,
		},
		{
			datapoint: "AC090",
			parameters: "Total Application Pipeline Results",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			thirdpartyamount: 0,
			thirdpartycount: 0,
			thirdpartyaverage: 0,
		},
	],
	closedloandata: [
		{
			datapoint: "type",
			parameters: "Loan Type",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC100",
			parameters: "Conventional",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC110",
			parameters: "FHA-Insured",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC120",
			parameters: "VA-Guaranteed",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC130",
			parameters: "FSA/RHS-Guaranteed",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC190",
			parameters: "Total Loan Type - Forward Mortgages",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "type",
			parameters: "Property Type",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC200",
			parameters: "One to Four Family Dwelling",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC210",
			parameters: "Manufactured Housing",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC220",
			parameters: "Multifamily Dwelling",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC290",
			parameters: "Total Property Type",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "type",
			parameters: "Purpose of Loan or Application",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC300",
			parameters: "Home Purchase",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC310",
			parameters: "Home Improvement",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC320",
			parameters: "Refinancing",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC390",
			parameters: "Total Purpose of Loan or Application",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC400",
			parameters: "HOEPA",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "type",
			parameters: "Lien Status",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC500",
			parameters: "First Lien",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC510",
			parameters: "Subordinate Lien",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC520",
			parameters: "Not Secured by a Lien",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC590",
			parameters: "Total Lien Status",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "type",
			parameters: "Fee Information",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC600",
			parameters: "Broker Fees Collected - Forward Mortgages",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC610",
			parameters: "Lender Fees Collected - Forward Mortgages",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "type",
			parameters: "Loan Type",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC700",
			parameters: "HECM - Standard",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC710",
			parameters: "HECM - Saver",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC720",
			parameters: "Proprietary / Other",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC790",
			parameters: "Total Loan Type - Reverse Mortgages",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "type",
			parameters: "Purpose of Reverse Mortgage",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC800",
			parameters: "Home Purchase",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC810",
			parameters: "Other",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC890",
			parameters: "Total Purpose of Reverse Mortgage",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "type",
			parameters: "Fee Information",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC620",
			parameters: "Broker Fees Collected - Reverse Mortgages",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC630",
			parameters: "Lender Fees Collected - Reverse Mortgages",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "type",
			parameters: "Forward and Reverse Mortgages Loans",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC900",
			parameters: "Total Loans Brokered by your Company",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC910",
			parameters: "Total Loans Funded by your Company",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "type",
			parameters: "QM and Non-QM",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC920",
			parameters: "Qualified Mortgage (QM)",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC930",
			parameters: "Non-Qualified Mortgage (Non-QM)",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC940",
			parameters: "Non-Subject to QM",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC990",
			parameters: "Total Closed Loans",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "type",
			parameters: "Repurchase Information",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},
		{
			datapoint: "AC1000",
			parameters: "Loans Made and Assigned but Required to Repurchase in Period",
			brokeredamount: 0,
			brokeredcount: 0,
			brokeredaverage: 0,
			NDCamount: 0,
			NDCcount: 0,
			NDCaverage: 0,
		},

	],
	revenuedata: [
		{
			datapoint: "AC1100",
			parameters: "Gross Revenue From Operations",
			amount: 0,
			count: 0,
			average: 0,
		},
	],
	mlodata: [],
}

export const callReportFieldIndex = {
	applicationdata: {
		AC010: 0,
		AC020: 1,
		AC030: 2,
		AC040: 3,
		AC050: 4,
		AC060: 5,
		AC062: 6,
		AC064: 7,
		AC065: 8,
		AC066: 9,
		AC070: 10,
		AC080: 11,
		AC090: 12,
	},
	closedloandata: {
		AC100: 1,
		AC110: 2,
		AC120: 3,
		AC130: 4,
		AC190: 5,
		AC200: 7,
		AC210: 8,
		AC220: 9,
		AC290: 10,
		AC300: 12,
		AC310: 13,
		AC320: 14,
		AC390: 15,
		AC400: 16,
		AC500: 18,
		AC510: 19,
		AC520: 20,
		AC590: 21,
		AC600: 23,
		AC610: 24,
		AC700: 26,
		AC710: 27,
		AC720: 28,
		AC790: 29,
		AC800: 31,
		AC810: 32,
		AC890: 33,
		AC620: 35,
		AC630: 36,
		AC900: 38,
		AC910: 39,
		AC920: 41,
		AC930: 42,
		AC940: 43,
		AC990: 44,
		AC1000: 46,
	},
	revenuedata: {
		AC1100: 0,
	},
}

export const allIncomeTypes = {
    VOE: 'VOE',
    VOE24Mo: '2-Year VOE',
    PersonalBankStatement12Mo: '1-Year personal bank statement',
    PersonalBankStatement24Mo: '2-Year personal bank statement',
    BusinessBankStatement12Mo: '1-Year business bank statement',
    BusinessBankStatement24Mo: '2-Year business bank statement',
    Form109924Mo: '2-Year form 1099',
    Form109912Mo: '1-Year form 1099',
    PL12: '1-Year P & L',
    PL24: '2-Year P & L',
    AssetUtilization: 'Asset utilization',
    DebtServiceCoverageRatio: 'DSCR',
}
